import React, { useState, useEffect, useCallback, Fragment, memo } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth } from "../Auth";
import  {             
            Button,
            Checkbox,
            Chip,
            Dialog,
            DialogActions,
            DialogContent,
            Fab,
            FormControlLabel,
            Grid,
            Grow,
            IconButton,
            LinearProgress,
            Menu,
            MenuItem,
            Paper,
            Slider,
            Switch,          
            TableBody,
            TableHead,
            TablePagination,
            TableSortLabel,
            TableRow,
            TextField,
            Tooltip,
            withWidth
} from '@material-ui/core';
import { 
            AccountBalance as AccountBalanceIcon,        
            Add as AddIcon,
            Autorenew as AutorenewIcon,
            BorderVertical as BorderVerticalIcon,
            Brush as BrushIcon,
            Build as BuildIcon,
            CheckBox as CheckBoxIcon,
            CheckCircle as CheckCircleIcon,
            CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
            ChevronLeft as ChevronLeftIcon,
            ChevronRight as ChevronRightIcon,
            Clear as ClearIcon,
            DateRange as DateRangeIcon,
            Delete as DeleteIcon,
            Description as DescriptionIcon,
            Done as DoneIcon,
            FilterList as FilterListIcon,
            HighlightOff as HighlightOffIcon,
            LocalAtm as LocalAtmIcon,
            MarkunreadMailbox as MarkunreadMailboxIcon,
            MonetizationOn as MonetizationOnIcon,
            MoreVert as MoreVertIcon,
            NavigateNext as NavigateNextIcon,
            PictureAsPdf as PictureAsPdfIcon,
            Save as SaveIcon,
            Search as SearchIcon,
            Visibility as VisibilityIcon,
            ViewWeek as ViewWeekIcon,
} from '@material-ui/icons';
import FacebookCircularProgress from '../Elementos/FacebookCircularProgress';
import styled from 'styled-components';
import { Autocomplete } from '@material-ui/lab';
import {
    Avatar as AvatarAntd,
    Button as ButtonAntd,
    Image as ImageAntd,
    Modal as ModalAntd,
    Popconfirm, 
    Segmented,
    Tooltip as TooltipAntd, 
    Upload,
} from 'antd';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import { 
    AppstoreAddOutlined as AppstoreAddOutlinedIcon,
    DollarOutlined as DollarOutlinedIcon,
    LoadingOutlined as LoadingOutlinedIcon,
    UploadOutlined
}from '@ant-design/icons';
import {
    TableContainerYounet,
    TableYounet,
    TheadYounetStyledFixed,
    TheadYounetStyled,
} from '../Elementos/TablaContainerYounet';
import PdfElement from '../Elementos/PdfElement';
import ExcelComponent from '../Elementos/ExcelComponent';
const moment = require('moment-timezone'); 
const arrMeses = ['','Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const laZona="America/Guayaquil";


    const useStyles = makeStyles((theme) => ({
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2),
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1,
            color:'#fff'
        },
    }));

    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Grow direction="up" ref={ref} {...props} timeout={750} />;
    });

    const TdYounetStyledFixed = styled.td`
        color:${props => props.color ? props.color : 'black'};
        font-size:${props => props.fontSize ?  props.fontSize : '12px'};
        font-weight:${props => props.bolder ? 'bold' : 'none'};
        min-width:${props => props.width || 60};
        width:${props => props.width || 60};
        padding-top:${props => props.element ? '0px' : '5px'}; 
        text-align:${props => props.align ? props.align : 'left'};
        background:#ffffff;
        border-bottom: 1px solid #E5E8E8;
        display:block;
        height:50px;
        min-height:50px;
        max-height:50px;
        padding:10px; 
        position:sticky;
        z-index:1; 
        left:${props => props.left || '0px'};
        text-overflow: ellipsis; 
        white-space: nowrap;  
        overflow: hidden;
    `;

    const TdYounetStyled = styled.td`
        color:${props => props.color ? props.color : 'black'};
        font-size:${props => props.fontSize ?  props.fontSize : '12px'};
        font-weight:${props => props.bolder ? 'bold' : 'none'};
        min-width:${props => props.width || 60};
        width:${props => props.width || 60};
        padding-top:${props => props.element ? '0px' : '5px'}; 
        text-align:${props => props.align ? props.align : 'left'};
        background:transparent;
        border-bottom: 1px solid #E5E8E8;
        display:block;
        height:50px;
        min-height:50px;
        max-height:50px;
        padding:10px;   
        position:relative;
        left:0px;      
        text-overflow: ellipsis;    
        white-space: nowrap; 
        overflow: hidden;
    `;

    const TrYounetStyled = styled.tr`
        display:flex;
        height:50px;
        min-height:50px;
        max-height:50px;
        position:'sticky';
        top:0px;
        z-index:2;
        background-color:${props => props.selected ? 'LightBlue' : '#fff'};
        &:hover{
            background-color:Gainsboro
        }
    `;

    const headCellsColumn = [
        { id: 'Zona', numeric: false, disablePadding: false, label: 'ZONA', show:true, fixed:false, width:180, num:0, align:'center', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Nombres', numeric: false, disablePadding: false, label: 'NOMBRES', show:true, fixed:false, width:300, num:1, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'idForMikrotik', numeric: false, disablePadding: false, label: 'ID ', show:true, fixed:false, width:150, num:2, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Status', numeric: false, disablePadding: false, label: 'STATUS', show:true, fixed:false, width:120, num:3, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Tipo', numeric: false, disablePadding: false, label: 'TIPO', show:true, fixed:false, width:120, num:4, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Valor', numeric: true, disablePadding: false, label: 'VALOR', show:true, fixed:false, width:120, num:5, align:'left', fontSize:'16px', bolder:false , type:'number'    },
        { id: 'isMensual', numeric: false, disablePadding: false, label: 'MENSUAL', show:true, fixed:false, width:120, num:6, align:'left', fontSize:'16px', bolder:false , type:'switch'    },
        { id: 'Detalle', numeric: false, disablePadding: false, label: 'DETALLE', show:true, fixed:false, width:250, num:7, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Observacion', numeric: false, disablePadding: false, label: 'OBSERVACION', show:true, fixed:false, width:300, num:8, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Registro', numeric: false, disablePadding: false, label: 'REGISTRO', show:true, fixed:false, width:200, num:9, align:'left', fontSize:'16px', bolder:false , type:'date'    },
        { id: 'Modificacion', numeric: false, disablePadding: false, label: 'MODIFICACION', show:true, fixed:false, width:200, num:10, align:'center', fontSize:'16px', bolder:false , type:'date'    },
        
    ];

    const variablesObject = {
        title:'ADICIONALES',
        nameLocalStorage:'headersAdicionalesListado',
        api:'/api/Adicionales',
        apiFiltered:'/api/Adicionales/Filtradas',
        label:'ADICIONAL',
        apiMultiples:'/api/Multiples/Adicionales',
        isRowDown:true,
        rowDown:'Eventos',
        rowDownOk:'PAGAR',
        sumWidth:1350 + 30
    };

    const propsWidth = { general:100 };

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
          return -1;
        }
        if (b[orderBy] > a[orderBy]) {
          return 1;
        }
        return 0;
    };
      
    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };
      
    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    };

    const TheadYounetFixed = memo(({widthDefault, createSortHandler, order, orderBy, headCell, classes, headCells, align})=>{
        const [ leftValue, setLeftValue ] = useState('0px')
        
        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
            }else{
                let numero = 0;
                for(let i=0; i<headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
                setLeftValue(`${numero}px`)
            }
            
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        return(
            <TheadYounetStyledFixed width={widthDefault} left={leftValue} align={align}>
                <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)} 
                    style={{color:'#fff', textAlign:align}}
                >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                    ) : null}
                </TableSortLabel>
            </TheadYounetStyledFixed>
        );
    });

    const TheadYounet = memo(({widthDefault, createSortHandler, order, orderBy, headCell, classes, align})=>( 
        <TheadYounetStyled width={widthDefault} align={align}>
            <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)} 
                style={{color:'#fff', textAlign:align}}
            >
                {headCell.label}
                {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
                ) : null}
            </TableSortLabel>
        </TheadYounetStyled>
    ));

    const TdYounet = memo(((props)=>{
        const { minWidth, width, headCells, headCell, valueInfo, fixed, align, bolder, fontSize, idCell } = props
        const [ leftValue, setLeftValue ] = useState('0px');

        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
            }else{
                let numero = 0;
                for(let i=0; i < headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
               
                setLeftValue(`${numero}px`)
            }
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        
        return(
            <Fragment>
            {
                fixed ?
                <TdYounetStyledFixed 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={idCell === 'Status'? valueInfo === 'Activo'? 'green' : valueInfo === 'Pendiente' ? 'orange' : 'red' :'black' } 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    {valueInfo}
                </TdYounetStyledFixed>
                :
                <TdYounetStyled 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={idCell === 'Status'? valueInfo === 'Activo'? 'green' : valueInfo === 'Pendiente' ? 'orange' : 'red' :'black' } 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    {valueInfo}
                </TdYounetStyled>
            }
            </Fragment>
        )
        
        
    }));

    const TdYounetSwitch = memo(((props)=>{
        const { minWidth, width, headCells, headCell, valueInfo, fixed, align, bolder, fontSize, idCell } = props
        const [ leftValue, setLeftValue ] = useState('0px');

        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
            }else{
                let numero = 0;
                for(let i=0; i < headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
               
                setLeftValue(`${numero}px`)
            }
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        
        return(
            <Fragment>
            {
                fixed ?
                <TdYounetStyledFixed 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={idCell === 'Status'? valueInfo === 'Concluida'? 'green' : valueInfo === 'Anulada' ? 'orange' : 'red' :'black' } 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    {valueInfo ? 'SI' : 'NO'}
                </TdYounetStyledFixed>
                :
                <TdYounetStyled 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={idCell === 'Status'? valueInfo === 'Concluida'? 'green' : valueInfo === 'Anulada' ? 'orange' : 'red' :'black' } 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    {valueInfo ? 'SI' : 'NO'}
                </TdYounetStyled>
            }
            </Fragment>
        )
        
        
    }));

    function EnhancedTableHead(props) {
        
        const { classes, order, orderBy, onRequestSort, headCells, HandleChangeWidth } = props;

        const createSortHandler = (property) => (event) => {
          onRequestSort(event, property);
        };
    
        return (
            <TableHead style={{position:'sticky', top:0, zIndex:2}}>
                <TableRow style={{display:'flex'}} >
                    <TheadYounetStyled width={180} align='left'>
                        ACTIONS
                    </TheadYounetStyled>
                {headCells.map( headCell =>  
                    headCell.show && ( 
                        headCell.fixed 
                        ? 
                        <TheadYounetFixed  
                            headCells={headCells} 
                            HandleChangeWidth={HandleChangeWidth} 
                            key={headCell.id} 
                            widthDefault={headCell.width} 
                            createSortHandler={createSortHandler} 
                            order={order} 
                            orderBy={orderBy} 
                            headCell={headCell} 
                            classes={classes} 
                            align={headCell.align}
                            
                            />
                        : 
                        <TheadYounet  
                            headCells={headCells} 
                            HandleChangeWidth={HandleChangeWidth}
                            key={headCell.id} 
                            widthDefault={headCell.width} 
                            createSortHandler={createSortHandler} 
                            order={order} 
                            orderBy={orderBy} 
                            headCell={headCell} 
                            classes={classes} 
                            align={headCell.align}
                         />
                        
                ))}
                </TableRow>
            </TableHead>
        );
    };
    
    const FiltradoEl = ({ index, info, HandleAddFilter, HandleDeleteFilter, HandleAddInformacionFilter, headersColumn, DataZona, widthWin})=>{
        const [ elementValue, setElementValue ] = useState({ idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'O', type:''});

        useEffect(()=>{
            setElementValue({ idElement:info.idElement, valorElement:info.valorElement, numero:index, labelElement:info.labelElement, selectElement:info.selectElement, type:info.type})
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        const handleElementValue = (e)=>{
            setElementValue({...elementValue, valorElement:e.target.value});
        };

        const handleElementValueZona = (e, value, reason)=>{
            if(reason === 'select-option'){
                setElementValue({...elementValue, valorElement:value});
                const objeto = {...elementValue};
                objeto.valorElement = value;
                HandleAddInformacionFilter(objeto)
            }else{
                setElementValue({...elementValue, valorElement:''});
                const objeto = {...elementValue};
                objeto.valorElement = '';
                HandleAddInformacionFilter(objeto)
            }
        };

        const handlePreDeleteFilter = ()=>{
            HandleDeleteFilter(index);
        };

        const handlePreAddInfFilter = (e)=>{
            HandleAddInformacionFilter(elementValue)
        };

        const handleAutoComplete = (e, value)=>{
            if(value === '' || value === null){
                setElementValue({...elementValue, idElement:'', labelElement:'', valorElement:''});
            }else{ 
                const arrFilHeaders = headersColumn.filter(value2=> value2.label === value);
                if(arrFilHeaders.length > 0){
                    setElementValue({...elementValue, idElement:arrFilHeaders[0].id.toString(), labelElement:value, type:arrFilHeaders[0].type.toString()});
                }
                
            }
            
        };

        const handleSelectElement = (e)=>{
            setElementValue({...elementValue, selectElement:e.target.value});
        };

        const handleDatosMac = ({target})=>{
            var val = target.value.toUpperCase().replace(/[^\d|A-Z]/g, '').match(/.{1,2}/g || []);
            setElementValue({...elementValue, valorElement:val !== null ? val.join(":") : val});
        };


        if(index === 0){
            return( 
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}  key={`ElementMenu-Filtrado-${index}`}>
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5} style={{paddingTop:12}}>
                            <Autocomplete
                                id={`idElement-${index}`}
                                options={headersColumn}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                inputValue={elementValue.labelElement || ''}                         
                                onInputChange={handleAutoComplete}
                                size='small'
                            />
                        </Grid>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                elementValue.type === 'number' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={handleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={handlePreAddInfFilter}
                                    type='number'
                                />: elementValue.type === 'date' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={handleElementValue}
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={handlePreAddInfFilter}
                                    type='date'
                                />: elementValue.type === 'mac' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={handleDatosMac}
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={handlePreAddInfFilter}
                                />: elementValue.idElement === 'Zona' ?
                                <Autocomplete
                                    id={`valorElement-${index}`}
                                    options={DataZona}
                                    renderInput={(params) => <TextField {...params} fullWidth variant="outlined" label='Valor'/>}
                                    value={elementValue.valorElement || ''}
                                    onChange={handleElementValueZona}
                                    size='small'
                                    style={{marginTop:8}}
                                />: elementValue.idElement === 'ZonaService' ?
                                <Autocomplete
                                    id={`valorElement-${index}`}
                                    options={DataZona}
                                    renderInput={(params) => <TextField {...params} fullWidth variant="outlined" label='Valor'/>}
                                    value={elementValue.valorElement || ''}
                                    onChange={handleElementValueZona}
                                    size='small'
                                    style={{marginTop:8}}
                                />:
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={handleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={handlePreAddInfFilter}
                                />
                            }
                        </Grid>
                        <Grid item xl={1} lg={2} md={2} sm={2} xs={2}>
                            <IconButton style={{marginTop:5}} onClick={HandleAddFilter}>
                                <AddIcon color='primary'/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            )
        }else{ 
            return(
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} key={`ElementMenu-Filtrado-${index}`}>
                    <Grid container justifyContent='center' spacing={1} >
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={widthWin === 'xs' ? 4 : 5} style={{paddingTop:12}}>
                            <Autocomplete
                                id={`idElement-${index}`}
                                options={headersColumn}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                inputValue={elementValue.labelElement || ''}
                                
                                onInputChange={handleAutoComplete}
                                size='small'
                            />
                        </Grid>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={4}>
                            {
                                elementValue.type === 'number' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={handleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={handlePreAddInfFilter}
                                    type='number'
                                />:elementValue.type === 'date' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={handleElementValue}
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={handlePreAddInfFilter}
                                    type='date'
                                />: elementValue.idElement === 'ZonaService' ?
                                <Autocomplete
                                    id={`valorElement-${index}`}
                                    options={DataZona}
                                    renderInput={(params) => <TextField {...params} fullWidth variant="outlined" label='Valor'/>}
                                    value={elementValue.valorElement || ''}
                                    onChange={handleElementValueZona}
                                    size='small'
                                    style={{marginTop:8}}
                                />:
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={handleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={handlePreAddInfFilter}
                                />
                            }
                            
                        </Grid>
                        <Grid item xl={2} lg={2} md={2} sm={2} xs={widthWin === 'xs' ? 4 : 3} >
                            <TextField
                                id={`selectElement-${index}`}
                                select
                                value={elementValue.selectElement || ''}
                                onChange={handleSelectElement}
                                style={{marginTop:15}}
                                onBlur={handlePreAddInfFilter}
                                margin='dense'
                            >
                                <MenuItem value={'O'}>O</MenuItem>
                                <MenuItem value={'Y'}>Y</MenuItem>
                            </TextField>
                            <IconButton size='small' onClick={handlePreDeleteFilter} style={{marginTop:15}} id={`bu-${index}`}>
                                <DeleteIcon style={{color:'red'}}/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>                                
            )
        }
    };

    const Roow = memo((props)=>{
        const { 
            enqueueSnackbar, 
            getBancos,
            headCells, 
            index, 
            handleClickRow, 
            handleDeleteElement,
            handleUpdateElement, 
            row, 
            selectionArr
        } = props;
        const [ statusRow, setStatusRow ] = useState(false);
        const [ continuoStatus, setContinuoStatus ] = useState(false);
        const [ getOpenRowDown, setOpenRowDown ] = useState(false);
        const [ getOpenRowDown2, setOpenRowDown2 ] = useState(false);
        const [ getOpenRowDown5, setOpenRowDown5 ] = useState(false);
        const [ getOpenRowDown25, setOpenRowDown25 ] = useState(false);
        const [ isAddingEvent, setAddingEvent ] = useState(false);
        const [ page, setPage ] = useState(0);
        const [ getEventNew, setEventNew ] = useState({ Valor:0, Registro:'2022-01-01'});
        const [ isDeletingEvent, setDeletingEvent ] = useState(false);
        const [ getBanco, setBanco ] = useState('');
        const [ fileList, setFileList] = useState([]);
        const [ uploading, setUploading] = useState(false);
        const [ getNombreImagen, setNombreImagen ] = useState('');
        const [ isPhoto, setPhoto ] = useState(false);
        const [ isPaying, setPaying ] = useState(false);
        const [ tipoPago, setTipoPago ] = useState('Efectivo');
        const [ isReadyRef, setReadyRef ] = useState(false);
        const [ openReferenciaPagos, setOpenReferenciaPagos ] = useState(false);
        const [ openModalBancario, setOpenModalBancario ] = useState(false);
        const [ isValidandoDeposito, setValidandoDeposito ] = useState(false);
        const [ isBancario, setBancario ] = useState(false);
        const [ refPago, setRefPago ] = useState('');
        const [ isPayBank, setPayBank ] = useState(false);
        const [ dataPays, setDataPays ] = useState({});
        const [ nextPays, setNextPays ] = useState(false);


        useEffect(()=>{
            const arr = [...selectionArr];
            const arrMap = arr.filter(el=>el._id === row._id);
            arrMap.length > 0 && setStatusRow(true);
        },[]);  // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(continuoStatus){
                setContinuoStatus(false);
                if(statusRow){
                    handleClickRow(statusRow, row)
                }else{
                    handleClickRow(statusRow, row)
                }
            }
        },[continuoStatus]); // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(isReadyRef){
                setReadyRef(false);
                if(tipoPago === 'Bancario'){
                    handleValidarDeposito();
                }else{
                    handlePagar();
                }
                
            }
        },[isReadyRef]) // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(nextPays){
                setNextPays(false);
                setPayBank(true);
            }
        },[nextPays]) // eslint-disable-line react-hooks/exhaustive-deps
    
        const handleEliminar = ()=>{
            Swal.fire({
                title:`DESEA ELIMINAR ESTE ${variablesObject.label}?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonColor:'#005596'
            }).then((result) => {
                if(result.isConfirmed){
                    fetch(variablesObject.api,{ method:'DELETE', body: JSON.stringify(row), headers:{'Content-Type': 'application/json'}}) 
                    .then(response=> response.json())
                    .then(result =>{
                        if(result.message){
                            enqueueSnackbar(result.message, {variant:'success'});
                            handleDeleteElement(row._id);
                        }else{
                            Swal.fire({
                                title: result.status,
                                icon:'error',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonColor:'#005596',
                                toast:true
                            })
                        }
                        
                    })
                }

            })          
        };

        const handleSuspender = ()=>{
            Swal.fire({
                title:`DESEA SUSPENDER ESTE ${variablesObject.label}?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonColor:'#005596'
            }).then((result) => {
                if(result.isConfirmed){
                    const objeto = {...row};
                    objeto.Status = 'Suspendido';
                    fetch(variablesObject.api,{ method:'PUT', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
                    .then(response=> response.json())
                    .then(result =>{
                        if(result.message){
                            enqueueSnackbar(result.message, {variant:'success'});
                            handleUpdateElement(objeto);
                        }else{
                            Swal.fire({
                                title: result.status,
                                icon:'error',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonColor:'#005596',
                                toast:true
                            })
                        }
                        
                    })
                }

            })          
        };

        const handleActivar = ()=>{
            Swal.fire({
                title:`DESEA ACTIVAR ESTE ${variablesObject.label}?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonColor:'#005596'
            }).then((result) => {
                if(result.isConfirmed){
                    const objeto = {...row};
                    objeto.Status = 'Activo';
                    fetch(variablesObject.api,{ method:'PUT', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
                    .then(response=> response.json())
                    .then(result =>{
                        if(result.message){
                            enqueueSnackbar(result.message, {variant:'success'});
                            handleUpdateElement(objeto);
                        }else{
                            Swal.fire({
                                title: result.status,
                                icon:'error',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonColor:'#005596',
                                toast:true
                            })
                        }
                        
                    })
                }

            })          
        };

        const HeadCellArr = headCells.map((value, index2)=>( 
            <Fragment key={`${index}_${index2}_${row._id}`} >
                { value.show &&
                    <Fragment>
                    {
                        value.type === 'switch' ?
                        <TdYounetSwitch
                            key={`${index}_${index2}_${row._id}_Td`}
                            width={value.width} 
                            minWidth={propsWidth.general} 
                            headCells={headCells} 
                            headCell={value} 
                            idCell={value.id}
                            valueInfo={row[value.id]}
                            fixed={value.fixed}
                            align={value.align}
                            fontSize={value.fontSize}
                            bolder={value.bolder}
                        />:
                        <TdYounet 
                            key={`${index}_${index2}_${row._id}_Td`}
                            width={value.width} 
                            minWidth={propsWidth.general} 
                            headCells={headCells} 
                            headCell={value} 
                            idCell={value.id}
                            valueInfo={row[value.id]}
                            fixed={value.fixed}
                            align={value.align}
                            fontSize={value.fontSize}
                            bolder={value.bolder}
                        />
                    }
                    </Fragment>
                }
            </Fragment>
        ));

        const HandlePreClickRow = ()=>{
            setStatusRow(!statusRow);
            setContinuoStatus(true);
        };

        const handleOpenRowDown = ()=>{ setOpenRowDown(true); };

        const handleCloseRowDown = ()=>{ setOpenRowDown(false); };

        const handleOpenRowDown5 = ()=>{ setOpenRowDown5(true); };

        const handleCloseRowDown5 = ()=>{ setOpenRowDown5(false); };

        const handleNextPage = ()=>{ setPage(page + 1); };
        
        const handleBackPage = ()=>{ setPage(page - 1); };

        const handleOpenRowDown2 = ()=>{ setOpenRowDown2(true); };

        const handleCloseRowDown2 = ()=>{ setOpenRowDown2(false); };
       
        const handleOpenRowDown25 = ()=>{ setOpenRowDown25(true); };

        const handleCloseRowDown25 = ()=>{ setOpenRowDown25(false); };

        const handleAddEvent = ()=>{ 
            setAddingEvent(true);
            const preTotal = row.Eventos.length === 0 ? 0 : row.Eventos.map(el=> el.Valor).reduce((a,b)=>  parseInt(a) + parseInt(b), 0);
            const total = parseInt(preTotal) + parseInt(getEventNew.Valor);
            if(total  > row.Valor){
                enqueueSnackbar('ERROR SOBREPASA EL TOTAL DEL ADICIONAL', {variant:'error'});
                setAddingEvent(false);
            }else if( total < row.Valor){
                const objeto = {...getEventNew};
                objeto.idAdicional = row._id;
                objeto.preId = `evento_${row._id}_${uuidv4()}`;
                fetch('/api/Adicionales/Eventos',{
                    method:'PUT',
                    body: JSON.stringify(objeto),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    setAddingEvent(false);
                    if(result._id){
                        enqueueSnackbar('EVENTO AÑADIDO',{variant:'success'});
                        const objeto2 = {...row};
                        const arr = [...row.Eventos];
                              arr.push(result);
                              objeto2.Eventos = arr;
                              handleUpdateElement(objeto2);
                        handleCloseRowDown2();
                        setEventNew({ Valor:0, Registro:'2022-01-01'});
                    }else{
                        enqueueSnackbar(result.status,{variant:'error'});                 
                    }
                });
            }else{
                const objeto = {...getEventNew};
                    objeto.preId = `evento_${row._id}_${uuidv4()}`;
                    objeto.idAdicional = row._id;
                fetch('/api/Adicionales/Pagar',{
                    method:'PUT',
                    body: JSON.stringify(objeto),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    setAddingEvent(false);
                    if(result._id){
                        enqueueSnackbar('PAGO REALIZADO',{variant:'success'});
                        const objeto2 = {...row};
                        const arr = [...row.Eventos];
                              arr.push(result);
                              objeto2.Eventos = arr;
                        handleUpdateElement(objeto2);
                        handleCloseRowDown2();
                    }else{
                        enqueueSnackbar(result.status,{variant:'error'});                 
                    }
                });
            }
            
        };

        const handleDeleteEvent = (idEvento_)=>{      
            const objeto = {...getEventNew};
                objeto.idAdicional = row._id;
                objeto.idEvento = idEvento_;
            if(row.isMensual){
                fetch('/api/Adicionales/Eventos',{
                    method:'DELETE',
                    body: JSON.stringify(objeto),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    const objeto2 = {...row};
                    const arr = [...row.Eventos];
                    const arr_ = arr.filter(el=> el._id !== idEvento_ );
                          objeto2.Eventos = arr_;
                          if(arr_.length === 0) objeto2.Status = "Pendiente";
                    handleUpdateElement(objeto2);
                    setDeletingEvent(false);
                    if(result.message){
                        enqueueSnackbar(result.message,{variant:'success'});
                    }else{
                        enqueueSnackbar(result.status,{variant:'error'});
                    }
                });
            }else{
                const val1_ = row.Eventos.length === 1 ? 0 : row.Eventos.filter(el=>el._id !== idEvento_).map(el=> parseInt(el.Valor)).reduce((a,b)=> a + b);
                if(val1_ < row.Valor){
                    fetch('/api/Adicionales/EventosStatus',{
                        method:'DELETE',
                        body: JSON.stringify(objeto),
                        headers:{
                            'Content-Type': 'application/json'
                        }
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        setDeletingEvent(false);
                        if(result.message){
                            enqueueSnackbar(result.message,{variant:'success'});
                            const objeto2 = {...row};
                            const arr = [...row.Eventos];
                            const arr_ = arr.filter(el=> el._id !== idEvento_ );
                                objeto2.Eventos = arr_;
                                if(arr_.length === 0) objeto2.Status = "Pendiente";
                            handleUpdateElement(objeto2);
                        }else{
                            enqueueSnackbar(result.status,{variant:'error'});
                        }
                    });
                }else{
                    fetch('/api/Adicionales/Eventos',{
                        method:'DELETE',
                        body: JSON.stringify(objeto),
                        headers:{
                            'Content-Type': 'application/json'
                        }
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        setDeletingEvent(false);
                        if(result.message){
                            enqueueSnackbar(result.message,{variant:'success'});
                            const objeto2 = {...row};
                            const arr = [...row.Eventos];;
                            const arr_ = arr.filter(el=> el._id !== idEvento_ );
                                objeto2.Eventos = arr_;
                                if(arr_.length === 0) objeto2.Status = "Pendiente";
                            handleUpdateElement(objeto2);
                        }else{
                            enqueueSnackbar(result.status,{variant:'error'});
                        }
                    });
                }
            }
            
        };

        const handleInfoEvent = ({target})=>{ setEventNew({...getEventNew, [target.name]:target.value }) }

        const handlePagar = ()=>{
            if(row.isMensual){
                const laZona="America/Guayaquil";
                const laFecha = moment().tz(laZona).format();
                const objeto = {...getEventNew};
                    objeto.preId = `evento_${row._id}_${uuidv4()}`;
                    objeto.idAdicional = row._id;
                    objeto.Registro = laFecha.split('T')[0];
                    objeto.Banco = getBanco;
                    objeto.RefPago= refPago;
                    objeto.TipoPago = tipoPago;
                    objeto.isPhoto = isPhoto;
                    objeto.urlPhoto = `/refBancarias/${getNombreImagen}`;
                fetch('/api/Adicionales/Pagar',{
                    method:'PUT',
                    body: JSON.stringify(objeto),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    setAddingEvent(false);
                    if(result._id){
                        enqueueSnackbar('PAGO REALIZADO',{variant:'success'});
                        const objeto2 = {...row};
                        const arr = [...row.Eventos];
                                arr.push(result);
                                objeto2.Eventos = arr;
                                objeto2.Status = "Pagado";
                        handleUpdateElement(objeto);
                        setOpenModalBancario(false);
                        setOpenReferenciaPagos(false);
                        setTipoPago('Efectivo');
                        setBanco("");
                        setPaying(false);
                        setBancario(false);
                        setRefPago("");
                        setPhoto(false);
                        setFileList([]);
                        setUploading(false);
                        setNombreImagen('');
                    }else{
                        enqueueSnackbar(result.status,{variant:'error'});                 
                    }
                });
            }else{
                const preTotal = row.Eventos.length === 0 ? 0 : row.Eventos.map(el=> el.Valor).reduce((a,b)=>  parseInt(a) + parseInt(b));
                const val_1 = parseInt(preTotal);
                const val_2 = parseInt(row.Valor);
                if(val_1 < val_2){
                    const laZona="America/Guayaquil";
                    const laFecha = moment().tz(laZona).format();
                    const Total_ = val_2 - val_1;
                    const objeto = {...getEventNew};
                        objeto.preId = `evento_${row._id}_${uuidv4()}`;
                        objeto.idAdicional = row._id;
                        objeto.Registro = laFecha.split('T')[0];
                        objeto.Valor = Total_;
                        objeto.Banco = getBanco;
                        objeto.RefPago= refPago;
                        objeto.TipoPago = tipoPago;
                        objeto.isPhoto = isPhoto;
                        objeto.urlPhoto = `/refBancarias/${getNombreImagen}`;
                    fetch('/api/Adicionales/Pagar',{
                        method:'PUT',
                        body: JSON.stringify(objeto),
                        headers:{
                            'Content-Type': 'application/json'
                        }
                    }) 
                    .then(response=> response.json())
                    .then(result =>{
                        setAddingEvent(false);
                        if(result._id){
                            enqueueSnackbar('PAGO REALIZADO',{variant:'success'});
                            const objeto2 = {...row};
                            const arr = [...row.Eventos];
                                  arr.push(result);
                                  objeto2.Eventos = arr;
                                  objeto2.Status = "Pagado";
                            handleUpdateElement(objeto);
                            setOpenModalBancario(false);
                            setOpenReferenciaPagos(false);
                            setTipoPago('Efectivo');
                            setBanco("");
                            setPaying(false);
                            setBancario(false);
                            setRefPago("");
                            setPhoto(false);
                            setFileList([]);
                            setUploading(false);
                            setNombreImagen('');
                        }else{
                            enqueueSnackbar(result.status,{variant:'error'});                 
                        }
                    });
                }else{
                    enqueueSnackbar('TOTAL EVENTOS SOBREPASAN INSTALACION', {variant:'error'});
                }
            }
            
        };

        const handleSelectMes = (e,value,reason)=>{
            if(reason === 'select-option'){
                setEventNew({...getEventNew, Mes:value});
            }else{
                setEventNew({...getEventNew, Mes:''});
            }
        };

        const handleValidarDeposito = ()=>{
            if(refPago === ''){
                alert('INGRESE UN CODIGO DE DEPOSITO')
            }else{
                setValidandoDeposito(true);
                fetch('/api/recibos/validarDeposito',{ method:'POST', body: JSON.stringify({refPago:refPago}), headers:{'Content-Type': 'application/json'}}) 
                .then(response=> response.json())
                .then(result =>{
                    if(result.message){
                        enqueueSnackbar(result.message,{variant:'success'});
                        setTimeout(()=>{
                            setValidandoDeposito(false);
                            handlePagar();
                        },1000)
                        
                        
                    }else{
                        Swal.fire({
                            title: result.status,
                            icon:'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596'
                        })
                    }
                })
            }
            
        };

        const handleReferenciaPago = (value) => {
            if (value === "Efectivo") {
              setBancario(false);
              setTipoPago(value);
            } else {
              setBancario(true);
              setTipoPago(value);
            }
        };
    
        const handleContinuoRef = () => {
            if (isBancario) {
                setOpenModalBancario(true);
            } else {
                setReadyRef(true);
                setPaying(true);
            }
        };

        const propsUpload = {
            onRemove: (file) => {
                const index = fileList.indexOf(file);
                const newFileList = fileList.slice();
                newFileList.splice(index, 1);
                setFileList(newFileList);
            },
            beforeUpload: (file) => {
                setFileList([...fileList, file]);
                return false;
            },
            fileList,
        };
      
        const handleUpload = () => {
            if (isPhoto) {
                setPaying(true);
                const formData = new FormData();
                fileList.forEach((file) => {
                const d = new Date();
                const nombreImagen = `${row.idForMikrotik}_${
                    row._id
                }_${row.ageWork}_${d.getTime()}.${file.name
                    .split(".")
                    .pop()
                    .toString()}`;
                setNombreImagen(nombreImagen);
                formData.append("file", file, nombreImagen);
                });
                setUploading(true); // You can use any AJAX library you like
        
                fetch("/api/uploadRefPago", {
                method: "POST",
                body: formData,
                })
                .then((res) => res.json())
                .then((result) => {
                    if (result.message) {
                    setFileList([]);
                    enqueueSnackbar("Depósito Subido", { variant: "success" });
                    setReadyRef(true);
                    } else {
                    enqueueSnackbar("Fallo con el Servidor", { variant: "error" });
                    }
                })
                .catch(() => {
                    enqueueSnackbar("Fallo con el Servidor", { variant: "error" });
                    setPaying(false);
                })
                .finally(() => {
                    setUploading(false);
                });
            } else {
                setReadyRef(true);
                setPaying(true);
            }
        };

        const handleCloseModalBancario = ()=>{
            setOpenModalBancario(false);
            setRefPago('');
            setBanco('');
        };

        const handleCloseTipoPago = ()=>{
            setTipoPago('Efectivo');
            setBancario(false);
            setRefPago('');
            setBanco('');
            setOpenReferenciaPagos(false);   
        };

        const handleInfoPays = (data)=>{
            setDataPays(data);
            setNextPays(true);
        };


        return(
            <Fragment>
                <TrYounetStyled key={`fila-${row._id}`}  selected={statusRow}>
                <ModalAntd 
                    title="REF. PAGO" 
                    visible={isPayBank} 
                    onOk={()=>{setPayBank(false)}} 
                    onCancel={()=>{setPayBank(false);setDataPays({})}} 
                    okText='CERRAR'
                    cancelText='...'
                    destroyOnClose
                    cancelButtonProps={{disabled:true, display:'none'}}
                    >
                        <Grid container justifyContent="center" spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    id='tipo_younet'
                                    fullWidth
                                    value={dataPays.TipoPago || ''}
                                    variant='outlined'
                                    size='small'      
                                    label="TIPO PAGO"            
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id='fechapago_younet'
                                    fullWidth
                                    value={dataPays.Registro || ''}
                                    variant='outlined'
                                    size='small'  
                                    label="FECHA PAGO"                
                                />
                            </Grid>
                            { dataPays.Banco && dataPays.Banco !== "" ?
                                <>
                                <Grid item xs={12}>
                                <TextField
                                    id='banco_younet'
                                    fullWidth
                                    value={dataPays.Banco || ''}
                                    variant='outlined'
                                    size='small'   
                                    label="BANCO"                    
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id='refpago_younet'
                                    fullWidth
                                    value={dataPays.RefPago || ''}
                                    variant='outlined'
                                    size='small'  
                                    label="COMPROBANTE"                     
                                />
                            </Grid>
                            {
                                dataPays.isPhoto &&
                                <Grid item xs={12} style={{display:'grid', placeContent:'center'}}>
                                    <ImageAntd
                                        width={200}
                                        src={dataPays.urlPhoto}
                                    />
                                </Grid>
                            }
                            </> : null }
                        </Grid>
                </ModalAntd> 
                <ModalAntd
                    title="TIPO DE PAGO"
                    visible={openReferenciaPagos}
                    onCancel={handleCloseTipoPago}
                    onOk={handleContinuoRef}
                    okText="PROCEDER"
                    cancelText="RETROCEDER"
                    destroyOnClose
                    bodyStyle={{ display: "flex", justifyContent: "center" }}
                    okButtonProps={{ disabled: isPaying, loading: isPaying }}
                    >
                <Grid container justifyContent="center">
                    <Grid
                    item
                    xs={12}
                    style={{ display: "flex", justifyContent: "center" }}
                    >
                    <Segmented
                        value={tipoPago || ""}
                        onChange={handleReferenciaPago}
                        size="small"
                        options={[
                        {
                            label: (
                            <div style={{ padding: 4 }}>
                                <AvatarAntd
                                style={{ backgroundColor: "#87d068", paddingTop: 3 }}
                                icon={<LocalAtmIcon fontSize="small" />}
                                />
                                <div>EFECTIVO</div>
                            </div>
                            ),
                            value: "Efectivo",
                        },
                        {
                            label: (
                            <div style={{ padding: 4 }}>
                                <AvatarAntd
                                style={{
                                    backgroundColor: "MediumSeaGreen",
                                    paddingTop: 3,
                                }}
                                icon={<AccountBalanceIcon fontSize="small" />}
                                />
                                <div>BANCARIO</div>
                            </div>
                            ),
                            value: "Bancario",
                        },
                        ]}
                    />
                    </Grid>
                </Grid>
                </ModalAntd>
                <ModalAntd
                title="REFERENCIA BANCARIA"
                visible={openModalBancario}
                onCancel={handleCloseModalBancario}
                onOk={handleUpload}
                okText="VALIDAR"
                cancelText="RETROCEDER"
                destroyOnClose
                confirmLoading={isValidandoDeposito}
                okButtonProps={{ disabled: isPaying, loading: isPaying }}
                >
                <React.Fragment>
                    <TextField
                    id="Banco"
                    fullWidth
                    label="Banco"
                    value={getBanco || ""}
                    onChange={({ target }) => {
                        setBanco(target.value);
                    }}
                    variant="outlined"
                    size="small"
                    select
                    style={{ margin: 10 }}
                    >
                    {getBancos.map((el) => (
                        <MenuItem value={el.Banco} key={el._id}>
                        {el.Banco}
                        </MenuItem>
                    ))}
                    </TextField>
                    <TextField
                    id="refPago"
                    fullWidth
                    label="Num. Comprobante Pago"
                    value={refPago || ""}
                    onChange={({ target }) => {
                        setRefPago(target.value);
                    }}
                    variant="outlined"
                    size="small"
                    style={{ margin: 10 }}
                    />
                    <Grid
                    container
                    alignItems="center"
                    spacing={1}
                    style={{ margin: 10 }}
                    justifyContent="center"
                    >
                    <Grid item>NO FOTO</Grid>
                    <Grid item>
                        <Switch
                        checked={isPhoto}
                        onChange={({ target }) => {
                            setPhoto(target.checked);
                        }}
                        name="isPhoto"
                        color="primary"
                        />
                    </Grid>
                    <Grid item>FOTO</Grid>
                    </Grid>

                    {isPhoto ? (
                    <Upload {...propsUpload}>
                        <ButtonAntd
                        style={{ margin: 10 }}
                        icon={<UploadOutlined />}
                        loading={uploading}
                        >
                        {uploading ? "Subiendo" : "Adjuntar Depósito"}
                        </ButtonAntd>
                    </Upload>
                    ) : null}
                </React.Fragment>
                </ModalAntd>
                <ModalAntd 
                    title={variablesObject.rowDown} 
                    visible={getOpenRowDown} 
                    onCancel={handleCloseRowDown} 
                    okText={variablesObject.rowDownOk} 
                    onOk={()=>{setOpenReferenciaPagos(true)}}
                    okButtonProps={{disabled:row.Status === 'Pagado'? true : row.isMensual ? true : false  }}
                    width={800}
                    >                
                    <Grid container spacing={2} justifyContent='space-between' style={{padding:5, width:'100%', minHeight:360, border:'1px solid #D0D3D4', borderRadius:5}}>
                        <Grid item xs={12}>                   
                                <Grid container spacing={1} key={`row_Ev_${index}_0_`}>
                                    <Grid item xs={2}>
                                        <p>ACTION</p>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <p>VALOR</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <p>MES</p>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <p>ANIO</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <p>REGISTRO</p>
                                    </Grid>
                                </Grid>
                            
                        </Grid>
                        {variablesObject.isRowDown && <Grid item xs={12}>
                            <Paper variant="outlined" square style={{padding:10, width:'100%', minHeight:300}} >
                            {
                                row[variablesObject.rowDown]
                                .slice(page * 8, page * 8 + 8)
                                .map((el, index)=>( 
                                    <Grid container spacing={1} key={`row_Ev_${index}_0_`}>
                                        <Grid item xs={2}>
                                            <Grid 
                                                container 
                                                spacing={1}
                                                justifyContent='flex-start'>
                                                <Grid item>
                                                    <Popconfirm
                                                        title="DESEA ELIMINAR EVENTO?"
                                                        onConfirm={()=>{handleDeleteEvent(el._id)}}
                                                        okText="SI"
                                                        cancelText="NO"
                                                    >
                                                        <IconButton size='small' >
                                                            {isDeletingEvent ? <LoadingOutlinedIcon /> : <DeleteIcon style={{color:'red'}} />}
                                                            </IconButton>
                                                    </Popconfirm>  
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title="TIPO PAGO" arrow placement="top">
                                                    <span>
                                                        <IconButton
                                                        size="small"
                                                        color="primary"
                                                        onClick={()=>{handleInfoPays(el)}}
                                                        style={{ backgroundColor: "gainsboro" }}
                                                        >
                                                        <MonetizationOnIcon />
                                                        </IconButton>
                                                    </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={2}>
                                            {el.Valor}
                                        </Grid>
                                        <Grid item xs={3}>
                                            {el.Mes}
                                        </Grid>
                                        <Grid item xs={2}>
                                            {el.Anio}
                                        </Grid>
                                        <Grid item xs={3}>
                                            {el.Registro}
                                        </Grid>
                                    </Grid>
                                ))
                            }
                            </Paper>
                        </Grid>}
                        <Grid item xs={2} style={{display:'flex', justifyContent:'center', alignItems:'center'}}> 
                            <TooltipAntd title="AÑADIR EVENTO" color='purple' placement='right'>
                                <Popconfirm
                                    title="DESEA AÑADIR EVENTO?"
                                    onConfirm={handleOpenRowDown2}
                                    okText="SI"
                                    cancelText="NO"
                                >
                                    <ButtonAntd shape='circle' type="primary" icon={isAddingEvent ? <LoadingOutlinedIcon /> : <AppstoreAddOutlinedIcon />} size='large' disabled={row.Status === 'Pagado' ? true: false  } />
                                </Popconfirm>
                            </TooltipAntd>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper variant="outlined" style={{padding:10, width:'100%', minHeight:50}} >
                                <Grid container spacing={2} justifyContent='center'>
                                    <Grid item>
                                        <IconButton disabled={page === 0 ? true : false}  onClick={handleBackPage}>
                                            <ChevronLeftIcon/>
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        <IconButton disabled={(Math.ceil(row[variablesObject.rowDown].length / 8)) === (page + 1) ? true : row[variablesObject.rowDown].length <= 8 ? true : false} onClick={handleNextPage}>
                                            <ChevronRightIcon/>
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>                                  
                </ModalAntd> 
                <ModalAntd 
                    title={variablesObject.rowDown} 
                    visible={getOpenRowDown2} 
                    onCancel={handleCloseRowDown2} 
                    okText={'ADD'} 
                    onOk={handleAddEvent} >                
                    <Grid container spacing={2} justifyContent='space-between' style={{padding:5, width:'100%', border:'1px solid #D0D3D4', borderRadius:5}}>
                        <Grid item xs={6}>
                            <TextField 
                                id='Valor_Evento_'
                                name='Valor'
                                fullWidth
                                label='VALOR'
                                value={getEventNew.Valor || ''}
                                onChange={handleInfoEvent}
                                variant='outlined'
                                size='small'
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                id="Mes_Evento_"
                                options={arrMeses}
                                value={ getEventNew.Mes || ''}                              
                                renderInput={(params) => <TextField {...params} label="MES" variant="outlined" size='small' fullWidth color='primary'/>}
                                onChange={handleSelectMes}  
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField 
                                id='Anio_Evento_'
                                name='Anio'
                                fullWidth
                                label='ANIO'
                                value={getEventNew.Anio || ''}
                                onChange={handleInfoEvent}
                                variant='outlined'
                                size='large'
                                margin='dense'
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField 
                                id='Fecha_Evento_'
                                name='Registro'
                                fullWidth
                                label='REGISTRO'
                                value={getEventNew.Registro || '2022-01-01'}
                                onChange={handleInfoEvent}
                                variant='outlined'
                                size='large'
                                margin='dense'
                                type='date'
                            />
                        </Grid>
                    </Grid>                                  
                </ModalAntd> 
                <ModalAntd 
                    title={variablesObject.rowDown} 
                    visible={getOpenRowDown5} 
                    onCancel={handleCloseRowDown5} 
                    okText={variablesObject.rowDownOk} 
                    onOk={()=>{setOpenReferenciaPagos(true)}}
                    okButtonProps={{disabled:row.Status === 'Pagado'? true : row.isMensual ? true : false  }}
                    width={800}
                    >                
                    <Grid container spacing={2} justifyContent='space-between' style={{padding:5, width:'100%', minHeight:360, border:'1px solid #D0D3D4', borderRadius:5}}>
                        <Grid item xs={12}>                   
                                <Grid container spacing={1} key={`row_Ev_${index}_0_`}>
                                    <Grid item xs={3}>
                                        <p>ACTION</p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <p>VALOR</p>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <p>REGISTRO</p>
                                    </Grid>
                                </Grid>
                            
                        </Grid>
                        <Grid item xs={12}>
                            <Paper variant="outlined" square style={{padding:10, width:'100%', minHeight:300}} >
                            {
                                row[variablesObject.rowDown]
                                .slice(page * 8, page * 8 + 8)
                                .map((el, index)=>( 
                                    <Grid container spacing={1} key={`row_Ev_${index}_0_`}>
                                        <Grid item xs={3}>
                                        <Grid container justifyContent="flex-start" spacing={1}>
                                                <Grid item>
                                                    <Popconfirm
                                                        title="DESEA ELIMINAR EVENTO?"
                                                        onConfirm={()=>{handleDeleteEvent(el._id)}}
                                                        okText="SI"
                                                        cancelText="NO"
                                                    >
                                                        <IconButton size='small' >
                                                            {isDeletingEvent ? <LoadingOutlinedIcon /> : <DeleteIcon style={{color:'red'}}/>}
                                                            </IconButton>
                                                    </Popconfirm>
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title="TIPO PAGO" arrow placement="top">
                                                    <span>
                                                        <IconButton
                                                        size="small"
                                                        color="primary"
                                                        onClick={()=>{setPayBank(true)}}
                                                        style={{ backgroundColor: "gainsboro" }}
                                                        >
                                                        <MonetizationOnIcon />
                                                        </IconButton>
                                                    </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={3}>
                                            {el.Valor}
                                        </Grid>
                                        <Grid item xs={6}>
                                            {el.Registro}
                                        </Grid>
                                    </Grid>
                                ))
                            }
                            </Paper>
                        </Grid>
                        <Grid item xs={2} style={{display:'flex', justifyContent:'center', alignItems:'center'}}> 
                            <TooltipAntd title="AÑADIR EVENTO" color='purple' placement='right'>
                                <Popconfirm
                                    title="DESEA AÑADIR EVENTO?"
                                    onConfirm={handleOpenRowDown25}
                                    okText="SI"
                                    cancelText="NO"
                                >
                                    <ButtonAntd shape='circle' type="primary" icon={isAddingEvent ? <LoadingOutlinedIcon /> : <AppstoreAddOutlinedIcon />} size='large' disabled={row.Status === 'Pagado' ? true: false  } />
                                </Popconfirm>
                            </TooltipAntd>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper variant="outlined" style={{padding:10, width:'100%', minHeight:50}} >
                                <Grid container spacing={2} justifyContent='center'>
                                    <Grid item>
                                        <IconButton disabled={page === 0 ? true : false}  onClick={handleBackPage}>
                                            <ChevronLeftIcon/>
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        <IconButton disabled={(Math.ceil(row[variablesObject.rowDown].length / 8)) === (page + 1) ? true : row[variablesObject.rowDown].length <= 8 ? true : false} onClick={handleNextPage}>
                                            <ChevronRightIcon/>
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>                                  
                </ModalAntd> 
                <ModalAntd 
                    title={variablesObject.rowDown} 
                    visible={getOpenRowDown25} 
                    onCancel={handleCloseRowDown25} 
                    okText={'ADD'} 
                    onOk={handleAddEvent} >                
                    <Grid container spacing={2} justifyContent='space-between' style={{padding:5, width:'100%', border:'1px solid #D0D3D4', borderRadius:5}}>
                        <Grid item xs={6}>
                            <TextField 
                                id='Valor_Evento_'
                                name='Valor'
                                fullWidth
                                label='VALOR'
                                value={getEventNew.Valor || ''}
                                onChange={handleInfoEvent}
                                variant='outlined'
                                size='small'
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField 
                                id='Fecha_Evento_'
                                name='Registro'
                                fullWidth
                                label='REGISTRO'
                                value={getEventNew.Registro || '2022-01-01'}
                                onChange={handleInfoEvent}
                                variant='outlined'
                                size='small'
                                type='date'
                            />
                        </Grid>
                    </Grid>                                  
                </ModalAntd> 
                <TdYounetStyled minWidth={150} width={180}>
                        <Grid container spacing={1} style={{height:47, marginTop:-8}}>
                            <Grid item >
                                <Checkbox
                                    checked={statusRow}
                                    color='primary'
                                    onClick={HandlePreClickRow}
                                    style={{marginTop:-4}}
                                    size='small'
                                />
                            </Grid>
                            { row.isMensual === false &&
                                <Grid item>
                                    <Tooltip title={`PAGAR`} placement='top' arrow>
                                        <span>
                                        <IconButton color='primary' onClick={()=>{setOpenReferenciaPagos(true)}} size='small' disabled={ row.Status === 'Pagado' ? true : false}>
                                            <DoneIcon style={{color:'green'}} />
                                        </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>
                            }
                            
                            {
                                row.isMensual &&
                                <Fragment>
                                    {row.Status === 'Activo' ? 
                                    <Grid item>
                                        <Tooltip title={`SUSPENDER`} placement='top' arrow>
                                            <span>
                                            <IconButton color='primary' onClick={handleSuspender} size='small'>
                                                <HighlightOffIcon style={{color:'orange'}} />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>:
                                    <Grid item>
                                        <Tooltip title={`ACTIVAR`} placement='top' arrow>
                                            <span>
                                            <IconButton color='primary' onClick={handleActivar} size='small'>
                                                <CheckCircleIcon style={{color:'green'}} />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    }
                                    
                                </Fragment>
                            }
                            {
                                row.isMensual ?
                                <Fragment>
                                   { variablesObject.isRowDown &&
                                    <Grid item >
                                        <Tooltip title={variablesObject.rowDown} placement='top' arrow>
                                            <span>
                                                <IconButton aria-label="expand row" size="small" onClick={handleOpenRowDown} color='primary' style={{position:'relative', top:2}}>
                                                    <DollarOutlinedIcon style={{fontSize:21}} />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>}
                                </Fragment>:
                                <Fragment>
                                    {variablesObject.isRowDown &&
                                    <Grid item >
                                        <Tooltip title={variablesObject.rowDown} placement='top' arrow>
                                            <span>
                                                <IconButton aria-label="expand row" size="small" onClick={handleOpenRowDown5} color='primary' style={{position:'relative', top:2}}>
                                                    <DollarOutlinedIcon style={{fontSize:21}} />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>}
                                </Fragment>
                            } 
                            <Grid item >
                                <Tooltip title={`ELIMINAR`} placement='top' arrow>
                                    <span>
                                        <IconButton aria-label="expand row" size="small" onClick={handleEliminar} color='primary'>
                                            <DeleteIcon style={{color:'red'}} />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </Grid>                         
                        </Grid>
                    </TdYounetStyled>
                    { HeadCellArr }
                </TrYounetStyled>
            </Fragment>
        );
    });

    const RowHeadersStyle = memo(({rowInfo, HandleProcessHeaders, widthWin})=>{

        const { id, numeric, disablePadding, label, show, fixed, width, num, align, fontSize, bolder, type } = rowInfo;
        const [ infoRow, setInfoRow ] = useState({ id, numeric, disablePadding, label, show, fixed, width, num, align, fontSize, bolder, type });

        const HandleInformacion = (e)=>{
            setInfoRow({...infoRow, [e.target.name]:e.target.value})
        };

        const HandleSwitch = (e)=>{
            setInfoRow({...infoRow, bolder:e.target.checked})
        };

        const HandleProcess = ()=>{
            HandleProcessHeaders(infoRow);
        };

        const handleChangeWidth = (e, value)=>{
            setInfoRow({...infoRow, width:value})
        };

        const HandleReset = ()=>{
            const element = headCellsColumn.filter(value=> value.id === rowInfo.id)[0];
            HandleProcessHeaders(element);
        };

        return(
            <Paper elevation={2} style={{width:'100%', padding:10}}>
                <Grid container spacing={1}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2} style={{minHeight:40}}>
                            {
                                widthWin === 'xs' || widthWin === 'sm' ?
                                <Fragment>
                                    <Grid item xs={3}>
                                        <Tooltip  title='GUARDAR' placement='top'>
                                            <Fab color="primary" size='small' onClick={HandleProcess} >
                                                <SaveIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Tooltip  title='RESET' placement='top'>
                                            <Fab color="secondary" size='small' onClick={HandleReset} >
                                                <AutorenewIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item style={{textTransform:'uppercase', fontWeight:'bolder'}}>
                                        <Chip label={rowInfo.label}  color='secondary'style={{marginTop:5}}/>
                                    </Grid>
                                </Fragment>:
                                <Fragment>
                                    <Grid item style={{marginTop:2}}>
                                        <Button size='small' variant='contained' color='primary' onClick={HandleProcess} endIcon={<SaveIcon/>}> GUARDAR </Button> 
                                    </Grid>
                                    <Grid item style={{marginTop:2}}>
                                        <Button size='small' variant='contained' color='primary' onClick={HandleReset} endIcon={<AutorenewIcon/>}> RESET </Button> 
                                    </Grid>
                                    <Grid item style={{textTransform:'uppercase', fontWeight:'bolder'}}>
                                        <Chip label={rowInfo.label}  color='secondary'/>
                                    </Grid>
                                </Fragment>
                            }
                            
                        </Grid>
                    </Grid>
                    <Grid item>
                        <TextField 
                            id={`${rowInfo.id}_${rowInfo.label}`}
                            name={'align'}
                            value={infoRow.align ||''}
                            onChange={HandleInformacion}
                            fullWidth
                            margin='dense'
                            variant='outlined'
                            label='Alinear Texto'
                            select
                        >
                            <MenuItem  value={'left'}>
                                IZQUIERDA
                            </MenuItem>
                            <MenuItem  value={'center'}>
                                CENTRADO
                            </MenuItem>
                            <MenuItem  value={'right'}>
                                DERECHA
                            </MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item>
                        <TextField 
                            id={`${rowInfo.id}_${rowInfo.label}`}
                            name={'fontSize'}
                            value={infoRow.fontSize ||''}
                            onChange={HandleInformacion}
                            fullWidth
                            margin='dense'
                            variant='outlined'
                            label='Tamaño Texto'
                        />
                    </Grid>
                    <Grid item style={{width:100}}>
                        <Slider 
                            value={infoRow.width} 
                            onChange={handleChangeWidth} 
                            aria-labelledby="continuous-slider" 
                            step={5}
                            min={50}
                            max={600}
                        />
                        <p>Ancho:{infoRow.width}</p>
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            control={
                            <Switch
                                checked={infoRow.bolder}
                                onChange={HandleSwitch}
                                id={`${rowInfo.id}_${rowInfo.label}`}
                                color="primary"
                            />
                            }
                            label={'Negritas'}
                        />
                    </Grid>
                </Grid>
            </Paper>
        );      
    });

    const Elemento = ({widthWin})=>{
        const classes = useStyles();
        const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
        const checkedIcon = <CheckBoxIcon fontSize="small" />;
        const { setOpen, authTokens, setRuta, ageWork } = useAuth();
        const { enqueueSnackbar } = useSnackbar();
        const [ rows, setRows ] = useState([]);
        const [ backupsRow, setBackupsRow ] = useState([]);
        const [ order, setOrder] = useState('desc'); 
        const [ orderBy, setOrderBy] = useState(variablesObject.orderBy || 'Nombres');
        const [ page, setPage] = useState(0);
        const [ rowsPerPage, setRowsPerPage] = useState(10);
        const [ headersColumn, setHeadersColumn ] = useState(()=>{
            try{
                if(window.localStorage.getItem(variablesObject.nameLocalStorage)){
                    const headersStorage = window.localStorage.getItem(variablesObject.nameLocalStorage) ;
                    const headersParse = JSON.parse(headersStorage);
                    return headersParse
                }else{
                    return headCellsColumn
                }
            }catch(err){
                return headCellsColumn
            }
        });
        const [ openMenuColumn, setOpenMenuColumn ] = useState(null);
        const [ openMenuColumnFixed, setOpenMenuColumnFixed ] = useState(null);
        const [ isSavingHeaders, setSavingHeaders ] = useState(false);
        const [ openMenuFilter, setOpenMenuFilter ] = useState(false);
        const [ openMenuDate, setOpenMenuDate ] = useState(null);
        const [ openMenuPdf, setOpenMenuPdf ] = useState(null);
        const [ openMenuExcel, setOpenMenuExcel ] = useState(null);
        const [ openMenuStyles, setOpenMenuStyles ] = useState(false);
        const [ openMenuPosicion, setOpenMenuPosicion ] = useState(false);
        const [ arrFiltrado, setArrFiltrado ] = useState([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
        const [ elementDate, setElementDate ] = useState({ idElement:'', labelElement:'', Inicio:'', Final:''});
        const [ isFilterDate, setFilterDate ] = useState(false);
        const [ isFilterNow, setFilterNow ] = useState(false);
        const [ isElementFilterShow, setElementFilterShow ] = useState(true);
        const [ rowsFilter, setRowsFilter ] = useState([]);
        const [ rowsFilterDate, setRowsFilterDate ] = useState([]);
        const [ selectionArr, setSelectionArr ] = useState([]);
        const [ isReadyPdf, setReadyPdf ] = useState(false);
        const [ isSelectPdf, setSelectPdf ] = useState(false);
        const [ isContinuoPdf, setContinuoPdf ] = useState(false);
        const [ arrHeadersPdf, setArrHeadersPdf ]= useState([])
        const [ openSelectPersonsMail, setOpenSelectPersonsMail ] = useState(false);
        const [ Remitentes, setRemitentes ] = useState([]);
        const [ RemitentesAll, setRemitentesAll ] = useState([]);
        const [ isCharging, setCharging ] = useState(true);
        const [ getContinuoUnSelect, setContinuoUnSelect ] = useState(false);
        const [ DataZona, setDataZona ] = useState([]);
        // const [ InfoEmpresa, setInfoEmpresa ] = useState({});
        const [ openMenuBusqueda, setOpenMenuBusqueda ] = useState(null);
        const [ getSearch, setSearch ] = useState('');
        const [ getOptionSearch, setOptionSearch ] = useState('Nombres'); 
        const [ isShowBusqueda, setShowBusqueda ] = useState(true);
        const [ getMeses, setMeses ] = useState([]);
        const [ getZonas, setZonas ] = useState([]);
        const [ isProcessingFilter, setProcessingFilter ] = useState(false);
        const [ openFiltradoData, setOpenFiltradoData ] = useState(false);
        const [ getBancos, setBancos ] = useState([]);

        useEffect(()=>{
            setRuta('/Adicionales/Listado');
            setOpen(false); 
            const laFecha = moment().tz(laZona).format();
            const elMes = arrMeses[parseInt(laFecha.split('-')[1])]; 
            fetch(variablesObject.apiFiltered,{
                method:'POST',
                body: JSON.stringify({
                    Tipo:authTokens.Type,
                    Meses:[elMes],
                    Zonas:authTokens.Zonas.map(el=>el.Zona),
                    Usuario:authTokens.NombresReducidos,
                    isAll:authTokens.Type === 'ADMINISTRADOR' ? true : false,
                    Empresa:authTokens.Empresa,
                    ageWork
                }),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                setCharging(false);
                if(result.status){
                    enqueueSnackbar(result.status, {variant:'error'});
                }else{
                    setRows(result);
                    setBackupsRow(result);
                    setMeses([elMes]);
                    (async()=>{
                        const PeticionZona = await fetch('/api/zonas');
                        const resultZona = await PeticionZona.json();
                        // const getEmpresas = await fetch('/api/Empresas');
                        // const infEmpresas = await getEmpresas.json();
                        // const elEmpresa = infEmpresas.filter(el=> el.Empresa === authTokens.Empresa);
                        // setInfoEmpresa(elEmpresa[0]);
                        if(authTokens.Type === 'ADMINISTRADOR'){
                            setDataZona(resultZona.filter(el=> el.Empresa === authTokens.Empresa).map(elZona=>elZona.Zona)); 
                            setZonas(resultZona.filter(el=> el.Empresa === authTokens.Empresa).map(elZona=>elZona.Zona));
                        }else{
                            setDataZona(authTokens.Zonas.map(valZon=> valZon.Zona));
                            setZonas(authTokens.Zonas.map(valZon=> valZon.Zona))
                        }
                        const dataUser = await fetch('/api/users');
                        const infoUser = await dataUser.json();
                        const arrMails = infoUser.filter(el=> el.Empresa === authTokens.Empresa).map(elUser=> elUser.Mail);
                        setRemitentesAll(arrMails);
                        const getBanks = await fetch('/api/Bancos');
                        const infBanks = await getBanks.json();
                        setBancos(infBanks.filter(el=>el.Empresa === authTokens.Empresa));
                    })()
                }
            });
        },[]); // eslint-disable-line react-hooks/exhaustive-deps


        useEffect(()=>{
            if(isContinuoPdf){
                setContinuoPdf(false);
                setReadyPdf(true);
            }
        },[isContinuoPdf]); // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(getContinuoUnSelect){
                setTimeout(()=>{
                    setContinuoUnSelect(false);
                },500)
                
            }
        },[getContinuoUnSelect]); // eslint-disable-line react-hooks/exhaustive-deps


        
        const handleClickMenu = (event) => { setOpenMenuColumn(event.currentTarget);};

        const handleClickMenuFixed = (event) => { setOpenMenuColumnFixed(event.currentTarget);};

        const handleClickMenuFilter = (event) => {
            setOpenMenuFilter(true);
            setElementFilterShow(true);
        };

        const handleClickMenuDate = (event) => { setOpenMenuDate(event.currentTarget);};

        const handleClickMenuPdf = (event) => { setOpenMenuPdf(event.currentTarget);};

        const handleClickMenuExcel = (event) => {setOpenMenuExcel(event.currentTarget);};

        const handleCloseMenu = () => {setOpenMenuColumn(null)};

        const handleCloseMenuFixed = () => { setOpenMenuColumnFixed(null) };

        const handleCloseMenuFilter = () => {
            setOpenMenuFilter(false);
            setElementFilterShow(false);
        };

        const handleCloseMenuDate = () => { setOpenMenuDate(null) };

        const handleCloseMenuPdf = ()=> { setOpenMenuPdf(null) };

        const handleCloseMenuExcel = ()=> { setOpenMenuExcel(null) };

        const handleRequestSort = useCallback((event, property) => {
            const isAsc = orderBy === property && order === 'asc';
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(property);
        },[order, orderBy])
            
        const handleChangePage = (event, newPage) => { setPage(newPage) };
        
        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        };
    
        const HandleChangeSwitch = (e)=>{
            const arrMap = headersColumn.map(value=>{
                if(value.id === e.target.name){
                    let objeto = {...value};
                    objeto.show = e.target.checked;
                    return objeto;
                }else{
                    return value;
                }
            });
            setHeadersColumn(arrMap);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(arrMap))
        };
        
        const ElementMenu = headersColumn.map((value,index)=>{
            return(
                <MenuItem key={`ElementMenu-${index}`}>
                    <FormControlLabel
                        control={
                        <Switch
                            checked={value.show}
                            onChange={HandleChangeSwitch}
                            name={value.id}
                            color="primary"
                        />
                        }
                        label={value.label}
                    />
                </MenuItem>
            )
            
        });

        const HandleChangeSwitchFixed = (e)=>{
            const arrMap = headersColumn.map(value=>{
                if(value.id === e.target.name){
                    let objeto = {...value};
                    objeto.fixed = e.target.checked;
                    return objeto;
                }else{
                    return value;
                }
            });
            setHeadersColumn(arrMap);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(arrMap))
            setSavingHeaders(true);
            setOpenMenuColumnFixed(false)
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000)
        };

        const ElementMenuFixed = headersColumn.map((value,index)=>( 
                <MenuItem key={`ElementMenuFixed-${index}`}>
                    <FormControlLabel
                        control={
                        <Switch
                            checked={value.fixed}
                            onChange={HandleChangeSwitchFixed}
                            name={value.id}
                            color="primary"
                        />
                        }
                        label={value.label}
                    />
                </MenuItem>
        ));

        const HandleAddInformacionFilter = useCallback((objeto)=>{
            const arrF = arrFiltrado.map((value,index)=> {
                if(objeto.numero === index){
                    return objeto
                }else{
                    return value
                }
            })
            setArrFiltrado(arrF);
        },[arrFiltrado]);

        const HandleDeleteFilter = useCallback((infElement)=>{ 
            const arrF = arrFiltrado.filter((value,index)=> infElement !== index);
            setArrFiltrado(arrF);
        },[arrFiltrado]);

        const HandleAddFilter = useCallback(()=>{
            const cant = arrFiltrado.length;
            setArrFiltrado([...arrFiltrado, {numero:cant, valueElement:'', idElement:'', labelElement:'', selectElement:'O'} ]);
        },[arrFiltrado]);


        const ElementMenuFilter = arrFiltrado.map((value,index)=>
            <FiltradoEl 
                key={`filterElement-${index}`} 
                index={index} 
                info={value} 
                HandleAddFilter={HandleAddFilter} 
                HandleDeleteFilter={HandleDeleteFilter}
                HandleAddInformacionFilter={HandleAddInformacionFilter}
                headersColumn={headersColumn}
                DataZona={DataZona}
                widthWin={widthWin}
        />);

        const HandleProcessFilterElement = ()=>{
            const arrInfo = isFilterDate ? [...rows] : [...backupsRow];
            if(isFilterNow){
                console.log('isFilterNow');
                let dataNow = [ ];
                arrFiltrado.forEach((value,index)=>{
                    if(index === 0){
                        if(value.type === 'number'){
                            arrInfo.forEach((value2)=>{
                                if(value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))) dataNow.push(value2);
                            });
                        }else if(value.type === 'text'){
                            arrInfo.forEach((value2)=>{
                                if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))) dataNow.push(value2);
                            });
                        }else{
                            arrInfo.forEach((value2)=>{
                                if(value2[value.idElement] && (value2[value.idElement].toString() === value.valorElement.toString()))  dataNow.push(value2);
                            });
                        }
                    }else{
                        if(value.type === 'number'){
                            if(value.selectElement === 'O'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))) dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))
                                );
                            }
                        }else if(value.type === 'text'){
                            if(value.selectElement === 'O'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))) dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))
                                );
                            }          
                        }else{
                            if(value.selectElement === 'O'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase()))  dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    value2[value.idElement] && (value2[value.idElement].toString() === value.valorElement.toString())
                                );
                            }
                                
                        }
                    }
                }); 
                let hash = {};
                dataNow = dataNow.filter(o => hash[o._id] ? false : hash[o._id] = true);
                setRows(dataNow);
                setRowsFilter(dataNow);
            }else{
                console.log('!isFilterNow');
                if(arrFiltrado[0].valorElement === ''){
                    setOpenMenuFilter(false);
                    setTimeout(()=>{
                        Swal.fire({
                            title:'NO HAY ELEMENTOS QUE FILTRAR',
                            toast:true,
                            confirmButtonColor:'#0E3B5F',
                        });
                    },200);
                    
                }else{
                    let dataNow = [ ];
                    arrFiltrado.forEach((value,index)=>{
                        if(index === 0){
                            console.log('index0');
                            if(value.type === 'number'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (parseInt(value2[value.idElement]) === parseInt(value.valorElement))) dataNow.push(value2);
                                });
                            }else if(value.type === 'text'){
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))){ 
                                        dataNow.push(value2);
                                        console.log(value2);
                                    }
                                });
                            }else{
                                arrInfo.forEach((value2)=>{
                                    if(value2[value.idElement] && (value2[value.idElement].toString() === value.valorElement.toString()))  dataNow.push(value2);
                                });
                            }
                        }else{
                            console.log('!index0');
                            if(value.type === 'number'){
                                if(value.selectElement === 'O'){
                                    arrInfo.forEach((value2)=>{
                                        if(value2[value.idElement] && (parseInt(value2[value.idElement]) === parseInt(value.valorElement))) dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        value2[value.idElement] && (parseInt(value2[value.idElement]) === (parseInt(value.valorElement)))
                                    );
                                }
                            }else if(value.idElement === 'text'){
                                if(value.selectElement === 'O'){
                                    arrInfo.forEach((value2)=>{
                                        if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))) dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        value2[value.idElement] && (value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase()))
                                    );
                                } 
                            }else{
                                if(value.selectElement === 'O'){
                                    arrInfo.forEach((value2)=>{
                                        if(value2[value.idElement] && (value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase()))  dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        value2[value.idElement] && (value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase())
                                    );
                                }  
                            }
                        }
                    }); 
                    let hash = {};
                    dataNow = dataNow.filter(o => hash[o._id] ? false : hash[o._id] = true);
                    setFilterNow(true);
                    setRows(dataNow);
                    setRowsFilter(dataNow);
                }
            }
        };

        const HandleResetFilter = ()=>{
            setElementFilterShow(false);
            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}])
            setFilterNow(false);
            if(isFilterDate){
                setRows(rowsFilterDate);
            }else{
                setRows(backupsRow);
            }
            setTimeout(()=>{
                setElementFilterShow(true);
            },1000)
        };

        const HandleMenuDate = (e)=>{ setElementDate({...elementDate, [e.target.id]:e.target.value })};

        const HandleClearDate = ()=>{
            setElementDate({});
            setOpenMenuDate(null);
            setFilterDate(false);
        };

        const HandleProcessFilterDate = ()=>{
            if(elementDate.Inicio === '' || elementDate.Final === ''){
                if(elementDate.Inicio === ''){
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'FECHA DE INICIO REQUERIDA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }else{
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'FECHA DE FINAL REQUERIDA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }
            }else{
                const resultInicio = new Date(elementDate.Inicio)
                const resultFinal = new Date(elementDate.Final)
                if(elementDate.idElement === ''){
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'DEBE SELECCIONAR UNA FILA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }else{ 
                    if(resultInicio > resultFinal){ 
                        setOpenMenuDate(null);
                        Swal.fire({
                            title:'FECHA DE INICIO DEBE SER MENOR A LA FECHA FINAL',
                            toast:true,
                            confirmButtonColor:'#0E3B5F',
                            width:'450px'
                        });
                    }else{
                        if(isFilterNow){
                            const arrFil = [];
                            for(const a in rows){
                                const el ={...rows[a]};
                                const dataEl = el[elementDate.idElement];
                                if(dataEl !== null){  
                                    if(dataEl !== undefined){       
                                        if(dataEl !== ''){ 
                                            if(dataEl.length <= 10){
                                                const valFecha = new Date(dataEl)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha <= resultFinal) arrFil.push(el);
                                                } 
                                            }else{
                                                const valFecha2 = dataEl.split("T")[0].toString();
                                                const valFecha = new Date(valFecha2)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha.getTime() <= resultFinal.getTime()) arrFil.push(el);
                                                } 
                                            }
        
                                        }                  
                                    }}
                            }    
                            if(arrFil.length === 0){
                               alert('NO HAY ELEMENTOS QUE VISUALIZAR')
                            }else{
                                setFilterDate(true);
                                setOpenMenuDate(null);
                                setRows(arrFil);
                                setRowsFilterDate(arrFil);
                            } 
                        }else{
                            const arrFil = [];
                            for(const a in backupsRow){
                                const el ={...backupsRow[a]};
                                const dataEl = el[elementDate.idElement];
                                if(dataEl !== null){  
                                    if(dataEl !== undefined){       
                                        if(dataEl !== ''){ 
                                            if(dataEl.length <= 10){
                                                const valFecha = new Date(dataEl)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha <= resultFinal) arrFil.push(el);
                                                } 
                                            }else{
                                                const valFecha2 = dataEl.split("T")[0].toString();
                                                const valFecha = new Date(valFecha2)
                                                if(valFecha.getTime() >= resultInicio.getTime()){
                                                    if(valFecha.getTime() <= resultFinal.getTime()) arrFil.push(el);
                                                } 
                                            }
        
                                        }                  
                                    }}
                            }                           
                            if(arrFil.length === 0){
                               alert('NO HAY ELEMENTOS QUE VISUALIZAR')
                            }else{
                                setFilterDate(true);
                                setOpenMenuDate(null);
                                setRows(arrFil);
                                setRowsFilterDate(arrFil);
                            } 
                        }
                    }
                }
            }
            
        };

        const HandleResetFilterDate = ()=>{
            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''});
            setFilterDate(false);
            if(isFilterNow){
                setRows(rowsFilter)
            }else{
                setRows(backupsRow);
            }    
        };

        const handleAutoComplete = (e, value)=>{
            if(value === '' || value === null){
                setElementDate({...elementDate, idElement:'', labelElement:'', valorElement:''});
            }else{ 
                const arrFilHeaders = headersColumn.filter(value2=> value2.label === value);
                if(arrFilHeaders.length > 0){
                    setElementDate({...elementDate, idElement:arrFilHeaders[0].id.toString(), labelElement:value});
                }  
            }
            
        };

        const handleClickRow = useCallback((statusRow, row)=>{
            if(statusRow){
                const arr = [...selectionArr];
                arr.push(row);
                setSelectionArr(arr);
            }else{
                const arr = selectionArr.filter(value=> value._id !== row._id);
                setSelectionArr(arr);
            }
        },[selectionArr]);

        const HandleExportSelectPdf = ()=>{
            if(selectionArr.length === 0){
                setOpenMenuPdf(null);
                Swal.fire({
                    title:'NO HAY ELEMENTOS A EXPORTAR',
                    toast:true,
                    confirmButtonColor:'#0E3B5F',
                });
            }else{
                if(isReadyPdf){
                    const FiltHeaders = headersColumn.filter(value=> value.show);
                    const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                    const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                    setArrHeadersPdf(FiltHeaders2);
                    setReadyPdf(false);
                    setSelectPdf(true);
                    setContinuoPdf(true);
                }else{
                    const FiltHeaders = headersColumn.filter(value=> value.show);
                    const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                    const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                    setArrHeadersPdf(FiltHeaders2);
                    setSelectPdf(true);
                    setContinuoPdf(true);
                }
                
            }
        };

        const HandleExportAllPdf = ()=>{
            if(isReadyPdf){
                const FiltHeaders = headersColumn.filter(value=> value.show);
                const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                setArrHeadersPdf(FiltHeaders2);
                setReadyPdf(false);
                setSelectPdf(false);
                setContinuoPdf(true);
            }else{
                const FiltHeaders = headersColumn.filter(value=> value.show);
                const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                setArrHeadersPdf(FiltHeaders2);
                setSelectPdf(false);
                setContinuoPdf(true);
                
            }
        };

        const HandleClickPdf = useCallback(()=>{
            setTimeout(()=>{
                setReadyPdf(false);
            },2000)
        },[]);

        const handleCloseSelectPersonsMail = ()=>{ setOpenSelectPersonsMail(false); };

        const HandleRemitentes = (e, value)=>{ setRemitentes(value) };

        const HandleSelectPersonsMail = ()=>{
            if(selectionArr.length > 0){
                setOpenSelectPersonsMail(true);
            }else{
                enqueueSnackbar('SELECCIONE UNA FILA POR LO MENOS', {variant:'info'});
            }
        };

        const handleSendCorreos = ()=>{
            fetch('/SendMailsRows',{ 
                method: 'POST',
                body: JSON.stringify({Elementos:selectionArr, headersColumn, Remitentes}),
                headers:{'Content-Type':'application/json'}
            })
            .then(response=> response.json())
            .then(result =>{
                setOpenSelectPersonsMail(false);
                enqueueSnackbar('Correos Enviados', {variant:'success'});
            });
        };
        
        const HandleProcessHeaders = useCallback((dataHeadersStyle)=>{
            const headersResultStyles = headersColumn.map(value=>{
                if(value.id === dataHeadersStyle.id){
                    return dataHeadersStyle;
                }else{
                    return value;
                }
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles))
            setSavingHeaders(true);
            setOpenMenuStyles(false)
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        },[headersColumn]);

        const ElementMenuStyles = headersColumn.map((value,index)=>( 
            <Grid item key={`ElementMenuStyles_${index}`} xl={12} lg={12} md={12} sm={12} xs={12} >
                <RowHeadersStyle rowInfo={value} HandleProcessHeaders={HandleProcessHeaders} widthWin={widthWin}/>
            </Grid>       
        ));

        const handleOpenMenuStyles = ()=>{ setOpenMenuStyles(true) };

        const handleCloseMenuStyles = ()=>{ setOpenMenuStyles(false) };

        const handleHeadersPosicion = (e)=>{
            const idEl = e.target.id.split('_')[0];
            const arr =  headersColumn.map(value=>{
                if(value.id.toString() === idEl.toString()){
                    const objeto = {...value};
                    objeto.num = e.target.value;
                    return objeto;
                }else{
                    return value;
                }
            })
            setHeadersColumn(arr);
        };

        const ElementMenuPosicion = headersColumn.map((value,index)=>( 
            <Grid item style={{width:100}} key={`ElementFixed_${index}`}>
                <TextField 
                    id={`${value.id}_${value.num}`}
                    name={'num'}
                    value={value.num ||''}
                    onChange={handleHeadersPosicion}
                    fullWidth
                    margin='dense'
                    variant='outlined'
                    label={value.label}
                />
            </Grid>
        ));

        const handleClickMenuPosicion = () => { setOpenMenuPosicion(true)};
        
        const handleCloseMenuPosicion = ()=> { setOpenMenuPosicion(false) };

        const handleResetPosicion = ()=>{
            const headersResultStyles = [];
            headersColumn.forEach(value=>{
                headCellsColumn.forEach(value2=>{
                    if(value.id === value2.id){
                        const objeto = {...value};
                        objeto.num = value2.num;
                        headersResultStyles.push(objeto);
                    }
                })
            })
            headersResultStyles.sort(function (a, b) {
                if (a.num > b.num) {
                  return 1;
                }
                if (a.num < b.num) {
                  return -1;
                }
                return 0;
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles));
            setOpenMenuPosicion(false);
            setSavingHeaders(true);
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        };

        const handleProcessPosicion = ()=>{
            const headersResultStyles = headersColumn;
            headersResultStyles.sort(function (a, b) {
                if (a.num > b.num) {
                  return 1;
                }
                if (a.num < b.num) {
                  return -1;
                }
                return 0;
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles))
            setSavingHeaders(true);
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        };

        const handleDeleteMultiple = ()=>{
            Swal.fire({
                title:`DESEA ELIMINAR TODO(A)S ${variablesObject.title}?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonColor:'#005596'
            }).then((result) => {
                if (result.isConfirmed){
                    const objeto = {};
                    objeto.selectionArr = [...selectionArr];
                    fetch(variablesObject.apiMultiples,{ method:'DELETE', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
                    .then(response=> response.json())
                    .then(result =>{
                        if(result.message){
                            for(const x in selectionArr){
                                const objeto = {...selectionArr[x]};
                                handleDeleteElement(objeto._id);
                            }
                            setSelectionArr([]);
                            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
                            setFilterNow(false);
                            setFilterDate(false);
                            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''});
                            setContinuoUnSelect(true);
                            enqueueSnackbar(result.message, {variant:'success'});
                            
                        }else{
                            enqueueSnackbar(result.status, {variant:'error'});
                        }
                    })
                }
            })
        };

        const handleSelectionAll = ()=>{
            setSelectionArr(rows);
            setContinuoUnSelect(true);
        };

        const handleUnSelect = ()=>{
            setSelectionArr([]);
            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
            setFilterNow(false);
            setFilterDate(false);
            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''});
            setContinuoUnSelect(true);
        };

        const handleUpdateElement = useCallback((Row)=>{
            setRows((Rows)=>(
                Rows.map(el=>( 
                    el._id === Row._id 
                    ? Row
                    : el
                ))
            ));
            setBackupsRow((Rows)=>(
                Rows.map(el=>( 
                    el._id === Row._id 
                    ? Row
                    : el
                ))
            ));
        },[])

        const handleDeleteElement = useCallback((idRow)=>{
            setRows((Rows)=>(Rows.filter(el=>( el._id !== idRow ))));
            setBackupsRow((Rows)=>(Rows.filter(el=>( el._id !== idRow ))));
        },[]);

        const handleSearch = ({target})=>{
            setSearch(target.value);
            if(target.value === ''){
                setRows(backupsRow);
            }else{
                setRows(backupsRow.filter(el=>el[getOptionSearch]?.toString().toLowerCase().includes(target.value.toLowerCase())));
            }
        };

        const handleClickMenuBusqueda = (event) => {
            setOpenMenuBusqueda(event.currentTarget);};

        const handleCloseMenuBusqueda = () => { setOpenMenuBusqueda(null) };

        const handleShowBusqueda = ()=>{
            setShowBusqueda(el=>{
                if(el) {
                    setRows(backupsRow);
                    setSearch('');
                }
                return !el
            });
        };

        const handleProcesarFiltrado = ()=>{
            setProcessingFilter(true);
            if(getZonas.length === 0){
                alert('DEBE SELECCIONAR POR LO MENOS 1 ZONA');
                setProcessingFilter(false);
            }else{ 
                fetch(variablesObject.apiFiltered,{
                    method:'POST',
                    body: JSON.stringify({
                        Tipo:authTokens.Type,
                        Meses:getMeses,
                        Zonas:getZonas,
                        Usuario:authTokens.NombresReducidos,
                        isAll:false,
                        ageWork,
                        Empresa:authTokens.Empresa
                    }),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    setRows(result);
                    setBackupsRow(result);
                    setProcessingFilter(false);
                });
            }
        };

        const handleCloseFiltrado = ()=>{
            setOpenFiltradoData(false);
        };

        return(
            <Grid container style={{width:'100%', padding:'10px', overflow: 'hidden'}} justifyContent='center'>
                <Dialog
                    open={openMenuFilter}
                    onClose={handleCloseMenuFilter}
                    fullWidth
                    maxWidth={'sm'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                    disableEscapeKeyDown
                >
                    <DialogContent>
                        <Grid container justifyContent='center' spacing={1}>
                            { isElementFilterShow ? ElementMenuFilter
                            : <FacebookCircularProgress size={25} style={{marginTop:5}}/>}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent='center' spacing={2} style={{padding:15}}>
                            {
                                widthWin === 'xs' || widthWin === 'sm' ?
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='CERRAR' placement='top'>
                                            <Fab color="default" size='small' onClick={handleCloseMenuFilter} >
                                                <ClearIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='RESETEAR' placement='top'>
                                            <Fab color="secondary" size='small' onClick={HandleResetFilter} >
                                                <AutorenewIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='PROCESAR' placement='top'>
                                            <Fab color="primary" size='small' onClick={HandleProcessFilterElement}>
                                                <NavigateNextIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                </Fragment>:
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="default" fullWidth onClick={handleCloseMenuFilter} endIcon={<ClearIcon/>}>
                                            Cerrar
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="secondary" fullWidth onClick={HandleResetFilter} endIcon={<AutorenewIcon/>}>
                                            Resetear
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="primary" fullWidth onClick={HandleProcessFilterElement} endIcon={<NavigateNextIcon/>}>
                                            Procesar
                                        </Button>
                                    </Grid>
                                </Fragment>
                            }
                        </Grid>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openMenuStyles}
                    onClose={handleCloseMenuStyles}
                    fullWidth
                    maxWidth={'md'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                >
                    <DialogContent>
                        <Grid container spacing={2}>
                            {ElementMenuStyles}
                        </Grid>
                        
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={openMenuPosicion}
                    onClose={handleCloseMenuPosicion}
                    fullWidth
                    maxWidth={'md'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                >
                    <DialogContent>
                        <Grid container spacing={2}>
                            {ElementMenuPosicion}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent='center' spacing={2} style={{padding:15}}>
                            {
                                widthWin === 'xs' || widthWin === 'sm' ?
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='CERRAR' placement='top'>
                                            <Fab color="default" size='small' onClick={handleCloseMenuPosicion} >
                                                <ClearIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='RESETEAR' placement='top'>
                                            <Fab color="secondary" size='small' onClick={handleResetPosicion} >
                                                <AutorenewIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='PROCESAR' placement='top'>
                                            <Fab color="primary" size='small' onClick={handleProcessPosicion}>
                                                <NavigateNextIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                </Fragment>:
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="default" fullWidth onClick={handleCloseMenuPosicion} endIcon={<ClearIcon/>}>
                                            Cerrar
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="secondary" fullWidth onClick={handleResetPosicion} endIcon={<AutorenewIcon/>}>
                                            Resetear
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="primary" fullWidth onClick={handleProcessPosicion} endIcon={<NavigateNextIcon/>}>
                                            Procesar
                                        </Button>
                                    </Grid>
                                </Fragment>
                            }
                        </Grid>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openSelectPersonsMail}
                    onClose={handleCloseSelectPersonsMail}
                    fullWidth
                    maxWidth={'sm'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                    disableEscapeKeyDown
                >
                    <DialogContent>
                        <Autocomplete
                            id="Remitentes"
                            freeSolo
                            options={RemitentesAll}
                            value={Remitentes || ''}
                            onChange={HandleRemitentes}
                            multiple
                            renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  label="Remitentes"
                                />
                              )}
                        /> 
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' onClick={handleCloseSelectPersonsMail} color="default" style={{height:40}}>
                            CANCELAR
                        </Button>
                        <Button variant='contained' onClick={handleSendCorreos} color="primary" style={{margin:3, height:40}}>
                            ENVIAR
                        </Button>
                    </DialogActions>
                </Dialog>
                <ModalAntd 
                    title="FILTRADO DE INFORMACION" 
                    visible={openFiltradoData} 
                    onCancel={handleCloseFiltrado} 
                    onOk={handleProcesarFiltrado} 
                    okText='PROCESAR'
                    cancelText='CANCELAR'
                    bodyStyle={{display:'flex', justifyContent:'center'}}
                    destroyOnClose
                    width={500}
                    okButtonProps={{disabled:isProcessingFilter, loading:isProcessingFilter}}
                >
                    <Grid 
                        alignItems='center'
                        container
                        justifyContent='center'
                        spacing={2}
                    >
                        <Grid item xs={12}>
                            <Autocomplete
                                multiple
                                id="SelectionZones"
                                options={DataZona}
                                disableCloseOnSelect
                                renderOption={(option, { selected }) => (
                                    <React.Fragment>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option}
                                    </React.Fragment>
                                )}
                                value={getZonas || ''}  
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        setZonas([]);
                                    }else{
                                        setZonas(value);
                                    }
                                }}  
                                renderInput={(params) => (
                                    <TextField {...params} label="Zonas" variant="outlined" fullWidth color='primary'/>
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                multiple
                                id="SelectionMonths"
                                options={arrMeses}
                                disableCloseOnSelect
                                renderOption={(option, { selected }) => (
                                    <React.Fragment>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option}
                                    </React.Fragment>
                                )}
                                value={getMeses || ''}  
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        setMeses([]);
                                    }else{
                                        setMeses(value);
                                    }
                                }}  
                                renderInput={(params) => (
                                    <TextField {...params} label="Meses" variant="outlined" fullWidth color='primary'/>
                                )}
                            />
                        </Grid>
                    </Grid>

                    
                </ModalAntd> 
                <Grid item xs={12} >
                    <Grid container spacing={1} justifyContent='space-between' style={{padding:1}}>
                        {
                            widthWin === 'xs' ||  widthWin === 'sm'?
                            <Fragment>
                                <Grid item  lg={3} md={4} sm={10} xs={12}>
                                    {   isShowBusqueda ? 
                                        <Grid container justifyContent='space-between' alignItems='center' spacing={0}>
                                            <Grid item xs={9}>
                                                <TextField 
                                                    id='SearchOptions'
                                                    fullWidth
                                                    label='Busqueda'
                                                    onChange={handleSearch}  
                                                    placeholder={ getOptionSearch || '' }
                                                    size='small'
                                                    value={ getSearch || ''}
                                                    variant='outlined'
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Tooltip title='OPCIONES DE BUSQUEDA' placement='top' >
                                                    <span>
                                                    <IconButton 
                                                        color='primary' 
                                                        onClick={handleClickMenuBusqueda}  
                                                        aria-controls="menu-column-busqueda" 
                                                        aria-haspopup="true" 
                                                        size='small'
                                                    >                            
                                                        <MoreVertIcon />
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                                <Menu
                                                    id="menu-column-busqueda"
                                                    anchorEl={openMenuBusqueda}
                                                    keepMounted
                                                    open={Boolean(openMenuBusqueda)}
                                                    onClose={handleCloseMenuBusqueda}
                                                >
                                                    {
                                                        headersColumn.map((el, index)=>
                                                            <MenuItem 
                                                                key={`${el.id}_${index}_`} 
                                                                style={{width:'100%'}}
                                                                onClick={()=>{
                                                                    setOptionSearch(el.id);
                                                                    setOpenMenuBusqueda(null)
                                                                }}
                                                            >
                                                                {el.label}
                                                            </MenuItem>
                                                        )
                                                    }
                                                </Menu>   
                                            </Grid>
                                            <Grid item>
                                                <Tooltip title='OCULTAR BUSQUEDA' placement='top'>
                                                    <span>
                                                        <IconButton 
                                                            aria-controls="menu-column-busqueda" 
                                                            aria-haspopup="true" 
                                                            color='primary'
                                                            style={{ background:'dodgerblue', color:'#fff' }}
                                                            onClick={handleShowBusqueda}  
                                                            size='small'
                                                        >                            
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>:
                                        <Grid container justifyContent='center' alignItems='center' >
                                            <Grid item>
                                                <Chip label={variablesObject.title} color='secondary' />
                                            </Grid>
                                            <Grid item>
                                                <Tooltip title='MOSTRAR BUSQUEDA' placement='top'>
                                                    <span>
                                                        <IconButton 
                                                            aria-controls="menu-column-busqueda" 
                                                            aria-haspopup="true" 
                                                            color='primary'
                                                            onClick={handleShowBusqueda}  
                                                            size='small'
                                                        >                            
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    }
                                </Grid>
                                <Grid item xs={1}>
                                    <Tooltip title='VER' placement='top'>
                                        <span>
                                        <IconButton size='small' color='primary' onClick={handleClickMenu}  aria-controls="menu-column" aria-haspopup="true" style={{marginRight:2}}>                           
                                            <VisibilityIcon />
                                        </IconButton>
                                        </span>
                                    </Tooltip>         
                                    <Menu
                                        id="menu-column"
                                        anchorEl={openMenuColumn}
                                        keepMounted
                                        open={Boolean(openMenuColumn)}
                                        onClose={handleCloseMenu}
                                        >
                                        {ElementMenu}
                                    </Menu>
                                </Grid>
                                <Grid item xs={1}>
                                    <Tooltip title='FIJAR' placement='top' >
                                        <span>
                                        <IconButton size='small' color='primary' onClick={handleClickMenuFixed}  aria-controls="menu-column-fixed" aria-haspopup="true" style={{marginRight:2}}>                     
                                            <ViewWeekIcon />
                                        </IconButton>
                                        </span>
                                    </Tooltip> 
                                    <Menu
                                        id="menu-column-fixed"
                                        anchorEl={openMenuColumnFixed}
                                        keepMounted
                                        open={Boolean(openMenuColumnFixed)}
                                        onClose={handleCloseMenuFixed}
                                        >
                                        {ElementMenuFixed}
                                    </Menu>
                                </Grid>
                                <Grid item xs={1}>
                                    <Tooltip title='FILTRAR' placement='top' >
                                        <span>
                                        <IconButton size='small' color={isFilterNow ? 'secondary' : 'default'} onClick={handleClickMenuFilter} style={{marginRight:2}}>                      
                                            <FilterListIcon />
                                        </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={1}>
                                    <Tooltip title='FECHAS' placement='top' >
                                        <span>
                                        <IconButton size='small' color={isFilterDate ? 'secondary' : 'default'} onClick={handleClickMenuDate}  aria-controls="menu-column-date" aria-haspopup="true" style={{marginRight:2}}>                            
                                            <DateRangeIcon />
                                        </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Menu
                                        id="menu-column-date"
                                        anchorEl={openMenuDate}
                                        keepMounted
                                        open={Boolean(openMenuDate)}
                                        onClose={handleCloseMenuDate}
                                    >
                                        <MenuItem key={'ElementMenuDate-Columna'} style={{width:'100%'}}>
                                            <Autocomplete
                                                id={'AutoComplete-ElementDate'}
                                                options={headersColumn.filter(el=>el.type==='date')}
                                                getOptionLabel={option => option.label }
                                                renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                                inputValue={elementDate.labelElement || ''}
                                                onInputChange={handleAutoComplete}
                                                size='small'
                                                style={{width:'100%'}}
                                            />
                                        </MenuItem>
                                        <MenuItem key={'ElementMenuDate-Inicio'}>
                                            <TextField 
                                                id='Inicio'
                                                value={elementDate.Inicio || new Date()}
                                                onChange={HandleMenuDate}
                                                fullWidth
                                                margin='dense'
                                                type='date'
                                                label='Inicio'
                                                autoFocus
                                            />
                                        </MenuItem>
                                        <MenuItem key={'ElementMenuDate-Final'}>
                                            <TextField 
                                                id='Final'
                                                value={elementDate.Final ||  new Date()}
                                                onChange={HandleMenuDate}
                                                fullWidth
                                                margin='dense'
                                                type='date'
                                                label='Final'
                                                autoFocus
                                            />
                                        </MenuItem>
                                        <MenuItem key={'ElementMenuDate-Process'}>
                                            <Grid container justifyContent='center'>
                                                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                    <Fab color="default" size='small' onClick={HandleClearDate} >
                                                        <ClearIcon />
                                                    </Fab>
                                                </Grid>
                                                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                    <Fab color="secondary" size='small' onClick={HandleResetFilterDate} >
                                                        <AutorenewIcon />
                                                    </Fab>
                                                </Grid>
                                                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                    <Fab color="primary" size='small' onClick={HandleProcessFilterDate}>
                                                        <NavigateNextIcon />
                                                    </Fab>
                                                </Grid>
                                            </Grid>
                                        </MenuItem>
                                    </Menu>   
                                </Grid>
                                <Grid item xs={1}>
                                    <Tooltip title='EXPORT PDF' placement='top'>
                                        <span>
                                        <IconButton size='small' aria-controls="menu-cpdf" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuPdf} color='primary'>                          
                                            <PictureAsPdfIcon />
                                        </IconButton>
                                        </span>
                                    </Tooltip>  
                                    <Menu
                                        id="menu-pdf"
                                        anchorEl={openMenuPdf}
                                        keepMounted
                                        open={Boolean(openMenuPdf)}
                                        onClose={handleCloseMenuPdf}
                                    >
                                        <MenuItem onClick={HandleExportSelectPdf} >
                                            Export Select
                                        </MenuItem>
                                        <MenuItem onClick={HandleExportAllPdf} >
                                            Export All
                                        </MenuItem>
                                        <MenuItem style={{display:'flex', justifyContent:'center'}}>
                                            {
                                                isReadyPdf ? <PdfElement data={isSelectPdf ? selectionArr : rows} headersColumn={arrHeadersPdf} HandleClickPdf={HandleClickPdf}/>
                                                : '...'
                                            }
                                        </MenuItem>
                                    </Menu>
                                </Grid>
                                <Grid item xs={1}>         
                                    <Tooltip title='EXPORT EXCEL' placement='top'>
                                        <span>
                                        <IconButton size='small' aria-controls="menu-excel" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuExcel} color='primary'>                           
                                            <DescriptionIcon />
                                        </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Menu
                                        id="menu-excel"
                                        anchorEl={openMenuExcel}
                                        keepMounted
                                        open={Boolean(openMenuExcel)}
                                        onClose={handleCloseMenuExcel}
                                    >
                                        <MenuItem >
                                            {
                                                selectionArr.length === 0 ? <span onClick={()=>{ setOpenMenuExcel(null);
                                                    Swal.fire({
                                                        title:'NO HAY ELEMENTOS A EXPORTAR',
                                                        toast:true,
                                                        confirmButtonColor:'#0E3B5F',
                                                    });}}>Export Select</span>
                                                :<ExcelComponent data={selectionArr} titulo={'Export Select'} headersColumn={headersColumn}/>
                                            }
                                        </MenuItem>
                                        <MenuItem >
                                            <ExcelComponent data={rows} titulo={'Export All'} headersColumn={headersColumn} />
                                        </MenuItem>
                                    </Menu>
                                </Grid>
                                <Grid item xs={1}>
                                    <Tooltip title='CORREOS' placement='top'>
                                        <span>
                                        <IconButton size='small' color='primary' onClick={HandleSelectPersonsMail}  style={{marginRight:2}}>
                                            <MarkunreadMailboxIcon/>
                                        </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={1}>
                                    <Tooltip title='ESTILOS' placement='top'>
                                        <span>
                                        <IconButton size='small' style={{marginRight:2}} onClick={handleOpenMenuStyles} color='primary'>                           
                                            <BrushIcon />
                                        </IconButton>
                                        </span>
                                    </Tooltip>  
                                </Grid>
                                <Grid item xs={1}>
                                    <Tooltip title='POSICION' placement='top'>
                                        <span>
                                        <IconButton size='small' style={{marginRight:2}} onClick={handleClickMenuPosicion} color='primary'>
                                            <BorderVerticalIcon />
                                        </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={1}>
                                    <Tooltip title='SELECT ALL' placement='top'>
                                        <span>
                                        <IconButton size='small' style={{marginRight:2}} onClick={handleSelectionAll} color='primary'>
                                            <CheckBoxIcon />
                                        </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>
                                {
                                    selectionArr.length > 0 &&
                                    <Fragment>
                                    <Grid item xs={1}>
                                        <Tooltip title='DELETE ROWS' placement='top'>
                                            <span>
                                            <IconButton size='small' style={{marginRight:2}} onClick={handleDeleteMultiple} color='primary' >
                                                <DeleteIcon style={{color:'red'}}/>
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Tooltip title='UNSELECT ROWS' placement='top'>
                                            <span>
                                            <IconButton size='small' style={{marginRight:2}} onClick={handleUnSelect} color='secondary' >
                                                <CheckBoxOutlineBlankIcon /> 
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    </Fragment>
                                }
                            </Fragment> :
                            <Fragment>
                                <Grid item  lg={3} md={4} sm={10} xs={12}>
                                    {   isShowBusqueda ? 
                                        <Grid container justifyContent='space-between' alignItems='center' spacing={0}>
                                            <Grid item xs={9}>
                                                <TextField 
                                                    id='SearchOptions'
                                                    fullWidth
                                                    label='Busqueda'
                                                    onChange={handleSearch}  
                                                    placeholder={ getOptionSearch || '' }
                                                    size='small'
                                                    value={ getSearch || ''}
                                                    variant='outlined'
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Tooltip title='OPCIONES DE BUSQUEDA' placement='top' >
                                                    <span>
                                                    <IconButton 
                                                        color='primary' 
                                                        onClick={handleClickMenuBusqueda}  
                                                        aria-controls="menu-column-busqueda" 
                                                        aria-haspopup="true" 
                                                        size='small'
                                                    >                            
                                                        <MoreVertIcon />
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                                <Menu
                                                    id="menu-column-busqueda"
                                                    anchorEl={openMenuBusqueda}
                                                    keepMounted
                                                    open={Boolean(openMenuBusqueda)}
                                                    onClose={handleCloseMenuBusqueda}
                                                >
                                                    {
                                                        headersColumn.map((el, index)=>
                                                            <MenuItem 
                                                                key={`${el.id}_${index}_`} 
                                                                style={{width:'100%'}}
                                                                onClick={()=>{
                                                                    setOptionSearch(el.id);
                                                                    setOpenMenuBusqueda(null)
                                                                }}
                                                            >
                                                                {el.label}
                                                            </MenuItem>
                                                        )
                                                    }
                                                </Menu>   
                                            </Grid>
                                            <Grid item>
                                                <Tooltip title='OCULTAR BUSQUEDA' placement='top'>
                                                    <span>
                                                        <IconButton 
                                                            aria-controls="menu-column-busqueda" 
                                                            aria-haspopup="true" 
                                                            color='primary'
                                                            style={{ background:'dodgerblue', color:'#fff' }}
                                                            onClick={handleShowBusqueda}  
                                                            size='small'
                                                        >                            
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>:
                                        <Grid container justifyContent='center' alignItems='center' >
                                            <Grid item>
                                                <Chip label={variablesObject.title} color='secondary' />
                                            </Grid>
                                            <Grid item>
                                                <Tooltip title='MOSTRAR BUSQUEDA' placement='top'>
                                                    <span>
                                                        <IconButton 
                                                            aria-controls="menu-column-busqueda" 
                                                            aria-haspopup="true" 
                                                            color='primary'
                                                            onClick={handleShowBusqueda}  
                                                            size='small'
                                                        >                            
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    }
                                </Grid>
                                <Grid item>
                                    <Grid 
                                        container
                                        spacing={1}
                                        justifyContent='flex-start'
                                        alignItems='center'
                                    >
                                        <Grid item >
                                            <Tooltip title='VER' placement='top'>
                                                <span>
                                                <IconButton color='primary' onClick={handleClickMenu}  aria-controls="menu-column" aria-haspopup="true" style={{marginRight:2}}>                           
                                                    <VisibilityIcon />
                                                </IconButton>
                                                </span>
                                            </Tooltip>         
                                            <Menu
                                                id="menu-column"
                                                anchorEl={openMenuColumn}
                                                keepMounted
                                                open={Boolean(openMenuColumn)}
                                                onClose={handleCloseMenu}
                                                >
                                                {ElementMenu}
                                            </Menu>
                                        </Grid>
                                        <Grid item >
                                            <Tooltip title='FIJAR' placement='top' >
                                                <span>
                                                <IconButton color='primary' onClick={handleClickMenuFixed}  aria-controls="menu-column-fixed" aria-haspopup="true" style={{marginRight:2}}>                     
                                                    <ViewWeekIcon />
                                                </IconButton>
                                                </span>
                                            </Tooltip> 
                                            <Menu
                                                id="menu-column-fixed"
                                                anchorEl={openMenuColumnFixed}
                                                keepMounted
                                                open={Boolean(openMenuColumnFixed)}
                                                onClose={handleCloseMenuFixed}
                                                >
                                                {ElementMenuFixed}
                                            </Menu>
                                        </Grid>
                                        <Grid item>
                                            <Tooltip title='FILTRAR' placement='top' >
                                                <span>
                                                <IconButton color={isFilterNow ? 'secondary' : 'default'} onClick={handleClickMenuFilter} style={{marginRight:2}}>                      
                                                    <FilterListIcon />
                                                </IconButton>
                                                </span>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item>
                                            <Tooltip title='FECHAS' placement='top' >
                                                <span>
                                                <IconButton color={isFilterDate ? 'secondary' : 'default'} onClick={handleClickMenuDate}  aria-controls="menu-column-date" aria-haspopup="true" style={{marginRight:2}}>                            
                                                    <DateRangeIcon />
                                                </IconButton>
                                                </span>
                                            </Tooltip>
                                            <Menu
                                                id="menu-column-date"
                                                anchorEl={openMenuDate}
                                                keepMounted
                                                open={Boolean(openMenuDate)}
                                                onClose={handleCloseMenuDate}
                                            >
                                                <MenuItem key={'ElementMenuDate-Columna'} style={{width:'100%'}}>
                                                    <Autocomplete
                                                        id={'AutoComplete-ElementDate'}
                                                        options={headersColumn.filter(el=>el.type==='date')}
                                                        getOptionLabel={option => option.label }
                                                        renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                                        inputValue={elementDate.labelElement || ''}
                                                        onInputChange={handleAutoComplete}
                                                        size='small'
                                                        style={{width:'100%'}}
                                                    />
                                                </MenuItem>
                                                <MenuItem key={'ElementMenuDate-Inicio'}>
                                                    <TextField 
                                                        id='Inicio'
                                                        value={elementDate.Inicio || new Date()}
                                                        onChange={HandleMenuDate}
                                                        fullWidth
                                                        margin='dense'
                                                        type='date'
                                                        label='Inicio'
                                                        autoFocus
                                                    />
                                                </MenuItem>
                                                <MenuItem key={'ElementMenuDate-Final'}>
                                                    <TextField 
                                                        id='Final'
                                                        value={elementDate.Final ||  new Date()}
                                                        onChange={HandleMenuDate}
                                                        fullWidth
                                                        margin='dense'
                                                        type='date'
                                                        label='Final'
                                                        autoFocus
                                                    />
                                                </MenuItem>
                                                <MenuItem key={'ElementMenuDate-Process'}>
                                                    <Grid container justifyContent='center'>
                                                        <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                            <Fab color="default" size='small' onClick={HandleClearDate} >
                                                                <ClearIcon />
                                                            </Fab>
                                                        </Grid>
                                                        <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                            <Fab color="secondary" size='small' onClick={HandleResetFilterDate} >
                                                                <AutorenewIcon />
                                                            </Fab>
                                                        </Grid>
                                                        <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                            <Fab color="primary" size='small' onClick={HandleProcessFilterDate}>
                                                                <NavigateNextIcon />
                                                            </Fab>
                                                        </Grid>
                                                    </Grid>
                                                </MenuItem>
                                            </Menu>   
                                        </Grid>
                                        <Grid item>
                                            <Tooltip title='EXPORT PDF' placement='top'>
                                                <span>
                                                <IconButton aria-controls="menu-cpdf" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuPdf} color='primary'>                          
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                                </span>
                                            </Tooltip>  
                                            <Menu
                                                id="menu-pdf"
                                                anchorEl={openMenuPdf}
                                                keepMounted
                                                open={Boolean(openMenuPdf)}
                                                onClose={handleCloseMenuPdf}
                                            >
                                                <MenuItem onClick={HandleExportSelectPdf} >
                                                    Export Select
                                                </MenuItem>
                                                <MenuItem onClick={HandleExportAllPdf} >
                                                    Export All
                                                </MenuItem>
                                                <MenuItem style={{display:'flex', justifyContent:'center'}}>
                                                    {
                                                        isReadyPdf ? <PdfElement data={isSelectPdf ? selectionArr : rows} headersColumn={arrHeadersPdf} HandleClickPdf={HandleClickPdf}/>
                                                        : '...'
                                                    }
                                                </MenuItem>
                                            </Menu>
                                        </Grid>
                                        <Grid item>         
                                            <Tooltip title='EXPORT EXCEL' placement='top'>
                                                <span>
                                                <IconButton aria-controls="menu-excel" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuExcel} color='primary'>                           
                                                    <DescriptionIcon />
                                                </IconButton>
                                                </span>
                                            </Tooltip>
                                            <Menu
                                                id="menu-excel"
                                                anchorEl={openMenuExcel}
                                                keepMounted
                                                open={Boolean(openMenuExcel)}
                                                onClose={handleCloseMenuExcel}
                                            >
                                                <MenuItem >
                                                    {
                                                        selectionArr.length === 0 ? <span onClick={()=>{ setOpenMenuExcel(null);
                                                            Swal.fire({
                                                                title:'NO HAY ELEMENTOS A EXPORTAR',
                                                                toast:true,
                                                                confirmButtonColor:'#0E3B5F',
                                                            });}}>Export Select</span>
                                                        :<ExcelComponent data={selectionArr} titulo={'Export Select'} headersColumn={headersColumn}/>
                                                    }
                                                </MenuItem>
                                                <MenuItem >
                                                    <ExcelComponent data={rows} titulo={'Export All'} headersColumn={headersColumn} />
                                                </MenuItem>
                                            </Menu>
                                        </Grid>
                                        <Grid item>
                                            <Tooltip title='CORREOS' placement='top'>
                                                <span>
                                                <IconButton color='primary' onClick={HandleSelectPersonsMail}  style={{marginRight:2}}>
                                                    <MarkunreadMailboxIcon/>
                                                </IconButton>
                                                </span>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item>
                                            <Tooltip title='ESTILOS' placement='top'>
                                                <span>
                                                <IconButton style={{marginRight:2}} onClick={handleOpenMenuStyles} color='primary'>                           
                                                    <BrushIcon />
                                                </IconButton>
                                                </span>
                                            </Tooltip>  
                                        </Grid>
                                        <Grid item>
                                            <Tooltip title='POSICION' placement='top'>
                                                <span>
                                                <IconButton style={{marginRight:2}} onClick={handleClickMenuPosicion} color='primary'>
                                                    <BorderVerticalIcon />
                                                </IconButton>
                                                </span>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item>
                                            <Tooltip title='SELECT ALL' placement='top'>
                                                <span>
                                                <IconButton style={{marginRight:2}} onClick={handleSelectionAll} color='primary'>
                                                    <CheckBoxIcon />
                                                </IconButton>
                                                </span>
                                            </Tooltip>
                                        </Grid>
                                        {
                                            selectionArr.length > 0 &&
                                            <Fragment>
                                            <Grid item >
                                                <Tooltip title='DELETE ROWS' placement='top'>
                                                    <span>
                                                    <IconButton style={{marginRight:2}} onClick={handleDeleteMultiple} color='primary' >
                                                        <DeleteIcon style={{color:'red'}}/>
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                            <Grid item >
                                                <Tooltip title='UNSELECT ROWS' placement='top'>
                                                    <span>
                                                    <IconButton style={{marginRight:2}} onClick={handleUnSelect} color='secondary' >
                                                        <CheckBoxOutlineBlankIcon /> 
                                                    </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                            </Fragment>
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item style={{display:'flex', alignItems:'center'}}>
                                    <Tooltip title='OPCIONES' placement='top'>
                                        <span>
                                        <IconButton 
                                            color='secondary' 
                                            onClick={()=>{setOpenFiltradoData(info=> !info)}} 
                                            style={{backgroundColor:'dodgerblue', color:'#fff', padding:2}} 
                                            size='small'
                                        >
                                            <BuildIcon style={{margin:2}}/> 
                                        </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>
                            </Fragment> 
                        }
                    </Grid>
                </Grid>
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >
                    <Paper square style={{minHeight:widthWin === 'xl' ? '85vh' : widthWin === 'lg' ? '80vh' : '77vh',  maxHeight:widthWin === 'xl' ? '85vh' : widthWin === 'lg' ? '80vh' : '77vh'}}>
                        { isSavingHeaders ? 
                        <Grid container>
                            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} style={{height:'100%', display:'flex', justifyContent:'center', marginTop:'33vh'}}  >                                                                                                                                                                                                                  
                                <FacebookCircularProgress size={40} style={{alignSelf:'center'}}/>
                            </Grid>
                        </Grid>
                        :
                        <Fragment>
                        {isCharging && <LinearProgress color='secondary' />}
                        <TableContainerYounet maxHeight={widthWin === 'xl' ? '80vh' : widthWin === 'lg' ? '75vh' : '72vh'} minHeight={widthWin === 'xl' ? '80vh' : widthWin === 'lg' ? '75vh' : '72vh'}>
                            <TableYounet>
                                <EnhancedTableHead
                                    classes={classes}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={rows.length}
                                    headCells={headersColumn}
                                />                                              
                                    <TableBody>
                                    {   stableSort( rows, getComparator(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, index) => (   
                                            <Roow 
                                                key={row._id} 
                                                row={row} 
                                                index={index} 
                                                headCells={headersColumn} 
                                                handleClickRow={handleClickRow}
                                                handleUpdateElement={handleUpdateElement}                                     
                                                handleDeleteElement={handleDeleteElement}
                                                enqueueSnackbar={enqueueSnackbar}
                                                selectionArr={selectionArr}
                                                getBancos={getBancos}
                                            />                                                                                    
                                    ))}
                                    </TableBody>                         
                            </TableYounet>
                        </TableContainerYounet>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15, 20, 25]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage='Filas'
                        />
                        </Fragment>
                        }
                    </Paper>
                </Grid>
            </Grid>  
        )
    };

    function Elementos(props) {
        return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom',horizontal: 'center'}}>
            <Elemento widthWin={props.width}/>
        </SnackbarProvider>
    );
    };

    export default  withWidth()(Elementos);